/*! customs-scene-helpers 2025-05-10 */

!function(e) {
    if ("object" == typeof exports && "undefined" != typeof module) module.exports = e(); else if ("function" == typeof define && define.amd) define([], e); else {
        ("undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this).customsSceneHelpers = e();
    }
}(function() {
    return function a(i, s, c) {
        function u(t, e) {
            if (!s[t]) {
                if (!i[t]) {
                    var r = "function" == typeof require && require;
                    if (!e && r) return r(t, !0);
                    if (l) return l(t, !0);
                    var o = new Error("Cannot find module '" + t + "'");
                    throw o.code = "MODULE_NOT_FOUND", o;
                }
                var n = s[t] = {
                    exports: {}
                };
                i[t][0].call(n.exports, function(e) {
                    return u(i[t][1][e] || e);
                }, n, n.exports, a, i, s, c);
            }
            return s[t].exports;
        }
        for (var l = "function" == typeof require && require, e = 0; e < c.length; e++) u(c[e]);
        return u;
    }({
        1: [ function(e, t, r) {
            "use strict";
            var o = {
                model: null,
                modelComponents: null,
                recipe_v2: null,
                rootObj: null,
                sceneObject: null,
                modelBySize: [],
                hashMap: {},
                materialHashMap: {},
                baseUrl: "",
                swatches: [],
                swatchesRoot: "",
                assetsRoot: "",
                stitches: {},
                stitchesRoot: "",
                default_textures: {},
                applied_textures: {},
                material_options: {},
                ShaderMaterialService: !1,
                useRecipe: !1,
                $: !1,
                highlight_color: null,
                ground: !1,
                stitchingTextures: {},
                DEFAULT_BUMP_SCALE: .03,
                productOptionsItems: {},
                TOGGLE_BEHAVIOR: "toggle",
                SWATCH_BEHAVIOR: "swatch",
                tmpImageDir: "",
                canvasFactory: function(e, t) {
                    var r = document.createElement("canvas");
                    return e && (r.width = e), t && (r.height = t), r;
                },
                serverSide: t && t.exports,
                modelsPath: "",
                textureLoaderMode: {
                    name: "TextureLoader",
                    fileType: null,
                    format: null
                },
                swatchMaterialGroupsData: {},
                enableCustomShaders: !0
            }, n = e("./SceneHelpers/productOptions/");
            function a(t) {
                var r = this;
                return Object.keys(o).forEach(function(e) {
                    t && t.hasOwnProperty(e) ? (r[e] = t[e], delete t[e]) : r[e] = o[e];
                }), this.opts = t, this.applyColorMaterial = e("./SceneHelpers/swatches/applyColorMaterial"), 
                this.applyMaterial = e("./SceneHelpers/swatches/applyMaterial"), this.applyModelToScene = e("./SceneHelpers/model/applyModelToScene"), 
                this.applyShaders = e("./SceneHelpers/swatches/applyShaders"), this.applySwatch = e("./SceneHelpers/swatches/applySwatch"), 
                this.applySwatchMaterialOptions = e("./SceneHelpers/swatches/applySwatchMaterialOptions"), 
                this.addSceneObjectToModel = e("./SceneHelpers/model/addSceneObjectToModel"), this.addTextCanvasToModel = e("./SceneHelpers/personalization/addTextCanvasToModel"), 
                this.addTextToComponent = e("./SceneHelpers/personalization/addTextToComponent"), 
                this.addToCanvas = e("./SceneHelpers/textures/addToCanvas"), this.alphaTextureToTransparent = e("./SceneHelpers/textures/alphaTextureToTransparent"), 
                this.calculateXCoordOffSet = e("./SceneHelpers/personalization/calculateXCoordOffSet"), 
                this.changeSwatch = e("./SceneHelpers/swatches/changeSwatch"), this.changeModelMaterialSide = e("./SceneHelpers/model/changeModelMaterialSide"), 
                this.checkForUGCComponent = e("./SceneHelpers/recipe/checkForUGCComponent"), this.checkHashMap = e("./SceneHelpers/colorHashMap/checkHashMap"), 
                this.checkIfSwatchExists = e("./SceneHelpers/materialHashMap/checkIfSwatchExists"), 
                this.createCanvas = e("./SceneHelpers/textures/createCanvas"), this.createGrid = e("./SceneHelpers/personalization/createGrid"), 
                this.createMaterial = e("./SceneHelpers/materials/createMaterial"), this.cloneObject = e("./SceneHelpers/model/cloneObject"), 
                this.componentHasStitching = e("./SceneHelpers/stitches/componentHasStitching"), 
                this.consumeShaders = e("./SceneHelpers/shaders/consumeShaders"), this.dispose = e("./SceneHelpers/textures/dispose"), 
                this.disposeMaterial = e("./SceneHelpers/textures/disposeMaterial"), this.disposeMeshObject = e("./SceneHelpers/textures/disposeMeshObject"), 
                this.disposeTexture = e("./SceneHelpers/textures/disposeTexture"), this.findChildrenByName = e("./SceneHelpers/model/findChildrenByName"), 
                this.getTextCanvasTexture = e("./SceneHelpers/personalization/getTextCanvasTexture"), 
                this.getTextureFactory = e("./SceneHelpers/textures/getTextureFactory"), this.getDefaultTextures = e("./SceneHelpers/textures/getDefaultTextures"), 
                this.getGround = e("./SceneHelpers/ground/getGround"), this.getHashMap = e("./SceneHelpers/colorHashMap/getHashMap"), 
                this.getHighlightColor = e("./SceneHelpers/colorHashMap/getHighlightColor"), this.getMaterialComponent = e("./SceneHelpers/materialHashMap/getMaterialComponent"), 
                this.getModel = e("./SceneHelpers/model/getModel"), this.getModelComponents = e("./SceneHelpers/model/getModelComponents"), 
                this.getModelName = e("./SceneHelpers/model/getModelName"), this.getModelPosition = e("./SceneHelpers/model/getModelPosition"), 
                this.getPdm = e("./SceneHelpers/pdm/getPdm"), this.getRecipe = e("./SceneHelpers/recipe/getRecipe"), 
                this.getRootObject = e("./SceneHelpers/scene/getRootObject"), this.getScale = e("./SceneHelpers/model/getScale"), 
                this.getScene = e("./SceneHelpers/scene/getScene"), this.getSceneCloneObjectByName = e("./SceneHelpers/scene/getSceneCloneObjectByName"), 
                this.getSceneObjectByName = e("./SceneHelpers/scene/getSceneObjectByName"), this.getSwatch = e("./SceneHelpers/swatches/getSwatch"), 
                this.getSwatches = e("./SceneHelpers/swatches/getSwatches"), this.getSwatchIdForComponent = e("./SceneHelpers/materialHashMap/getSwatchIdForComponent"), 
                this.getTextureLoader = e("./SceneHelpers/textures/getTextureLoader"), this.getUniform = e("./SceneHelpers/shaders/getUniform"), 
                this.getUVsFromBufferGeometry = e("./SceneHelpers/geometry/getUVsFromBufferGeometry"), 
                this.getUVsFromGeometry = e("./SceneHelpers/geometry/getUVsFromGeometry"), this.getUVType = e("./SceneHelpers/shaders/getUVType"), 
                this.hideSceneObject = e("./SceneHelpers/scene/hideSceneObject"), this.isNotFlipped = e("./SceneHelpers/model/isNotFlipped"), 
                this.loadFloorPassTexture = e("./SceneHelpers/textures/loadFloorPassTexture"), this.loadModel = e("./SceneHelpers/model/loadModel"), 
                this.loadModelBySize = e("./SceneHelpers/model/loadModelBySize"), this.loadTexture = e("./SceneHelpers/textures/loadTexture"), 
                this.loadTexturesApplyMaterials = e("./SceneHelpers/textures/loadTexturesApplyMaterials"), 
                this.loadMultipleTextures = e("./SceneHelpers/textures/loadMultipleTextures"), this.meshMaterialOverride = e("./SceneHelpers/swatches/meshMaterialOverride"), 
                this.parseModelComponents = e("./SceneHelpers/model/parseModelComponents"), this.removeComponentFromData = e("./SceneHelpers/colorHashMap/removeComponentFromData"), 
                this.removeModelBySize = e("./SceneHelpers/model/removeModelBySize"), this.removePersonalizationObject = e("./SceneHelpers/personalization/removePersonalizationObject"), 
                this.removeSceneObject = e("./SceneHelpers/scene/removeSceneObject"), this.removeSceneObjectByName = e("./SceneHelpers/scene/removeSceneObjectByName"), 
                this.replaceModel = e("./SceneHelpers/model/replaceModel"), this.replaceModelComponents = e("./SceneHelpers/model/replaceModelComponents"), 
                this.resetHashData = e("./SceneHelpers/colorHashMap/resetHashData"), this.returnColorObj = e("./SceneHelpers/colorHashMap/returnColorObj"), 
                this.returnCountComponentsForSwatch = e("./SceneHelpers/materialHashMap/returnCountComponentsForSwatch"), 
                this.returnHexComponent = e("./SceneHelpers/colorHashMap/returnHexComponent"), this.returnMaterial = e("./SceneHelpers/scene/returnMaterial"), 
                this.returnOverrideTexturesList = e("./SceneHelpers/textures/returnOverrideTexturesList"), 
                this.returnStitchColor = e("./SceneHelpers/stitches/returnStitchColor"), this.returnSceneColorObj = e("./SceneHelpers/colorHashMap/returnSceneColorObj"), 
                this.setComponentOptions = e("./SceneHelpers/model/setComponentOptions"), this.setDefaultTextures = e("./SceneHelpers/textures/setDefaultTextures"), 
                this.setGround = e("./SceneHelpers/ground/setGround"), this.setHighlightColor = e("./SceneHelpers/colorHashMap/setHighlightColor"), 
                this.setModel = e("./SceneHelpers/model/setModel"), this.setModelComponentsVisibility = e("./SceneHelpers/model/setModelComponentsVisibility"), 
                this.setModelName = e("./SceneHelpers/model/setModelName"), this.setModelPosition = e("./SceneHelpers/model/setModelPosition"), 
                this.setModelScale = e("./SceneHelpers/model/setModelScale"), this.setNewColorObj = e("./SceneHelpers/colorHashMap/setNewColorObj"), 
                this.setNewModelComponents = e("./SceneHelpers/model/setNewModelComponents"), this.setPdm = e("./SceneHelpers/pdm/setPdm"), 
                this.setRecipe = e("./SceneHelpers/recipe/setRecipe"), this.setRootObject = e("./SceneHelpers/scene/setRootObject"), 
                this.setScene = e("./SceneHelpers/scene/setScene"), this.setSceneObjectMaterial = e("./SceneHelpers/scene/setSceneObjectMaterial"), 
                this.setSceneObjectMaterialSide = e("./SceneHelpers/scene/setSceneObjectMaterialSide"), 
                this.setSceneObjectVisibility = e("./SceneHelpers/scene/setSceneObjectVisibility"), 
                this.setSwatches = e("./SceneHelpers/swatches/setSwatches"), this.setUniform = e("./SceneHelpers/shaders/setUniform"), 
                this.setTextureLoaderMode = e("./SceneHelpers/textures/setTextureLoaderMode"), this.showSceneObject = e("./SceneHelpers/scene/showSceneObject"), 
                this.simplifyUVAttributes = e("./SceneHelpers/geometry/simplifyUVAttributes"), this.storeMaterial = e("./SceneHelpers/materialHashMap/storeMaterial"), 
                this.updateComponentStitching = e("./SceneHelpers/stitches/updateComponentStitching"), 
                this.updateCurrentShader = e("./SceneHelpers/materials/updateCurrentShader"), this.updateMaterial = e("./SceneHelpers/materials/updateMaterial"), 
                this.updateMaterialOptions = e("./SceneHelpers/swatches/updateMaterialOptions"), 
                this.usingRecipe = e("./SceneHelpers/swatches/usingRecipe"), this.productOptions = n(this), 
                this.addProductOption = e("./SceneHelpers/recipe/addProductOption"), this.hasProductOption = e("./SceneHelpers/recipe/hasProductOption"), 
                this.removeProductOption = e("./SceneHelpers/recipe/removeProductOption"), this.convertToNormalTexture = e("./SceneHelpers/textures/convertToNormalTexture"), 
                this.loadImage = e("./SceneHelpers/textures/loadImage"), this.loadMaps = e("./SceneHelpers/textures/loadMaps"), 
                this.getGLTFBuffer = e("./SceneHelpers/gltf/getGLTFBuffer"), this.preloadAllModelTextures = e("./SceneHelpers/gltf/preloadAllModelTextures"), 
                this.simplifyModel = e("./SceneHelpers/gltf/simplifyModel"), this.setSwatchMaterialGroupsData = e("./SceneHelpers/swatchMaterialGroups/setSwatchMaterialGroupsData"), 
                this.getSwatchMaterialGroupsData = e("./SceneHelpers/swatchMaterialGroups/getSwatchMaterialGroupsData"), 
                this.applySwatchMaterialGroup = e("./SceneHelpers/swatchMaterialGroups/applySwatchMaterialGroup"), 
                this.validateSwatchMaterialGroup = e("./SceneHelpers/swatchMaterialGroups/validateSwatchMaterialGroup"), 
                this.overrideMeshOptions = e("./SceneHelpers/swatchMaterialGroups/overrideMeshOptions"), 
                this.saveAppliedTexture = e("./SceneHelpers/textures/saveAppliedTexture"), this.returnAppliedTexture = e("./SceneHelpers/textures/returnAppliedTexture"), 
                this;
            }
            var i = void 0;
            t.exports = function(e) {
                return i || (i = new a(e)), i;
            };
        }, {
            "./SceneHelpers/colorHashMap/checkHashMap": 2,
            "./SceneHelpers/colorHashMap/getHashMap": 3,
            "./SceneHelpers/colorHashMap/getHighlightColor": 4,
            "./SceneHelpers/colorHashMap/removeComponentFromData": 5,
            "./SceneHelpers/colorHashMap/resetHashData": 6,
            "./SceneHelpers/colorHashMap/returnColorObj": 7,
            "./SceneHelpers/colorHashMap/returnHexComponent": 8,
            "./SceneHelpers/colorHashMap/returnSceneColorObj": 9,
            "./SceneHelpers/colorHashMap/setHighlightColor": 10,
            "./SceneHelpers/colorHashMap/setNewColorObj": 11,
            "./SceneHelpers/geometry/getUVsFromBufferGeometry": 12,
            "./SceneHelpers/geometry/getUVsFromGeometry": 13,
            "./SceneHelpers/geometry/simplifyUVAttributes": 14,
            "./SceneHelpers/gltf/getGLTFBuffer": 15,
            "./SceneHelpers/gltf/preloadAllModelTextures": 16,
            "./SceneHelpers/gltf/simplifyModel": 17,
            "./SceneHelpers/ground/getGround": 18,
            "./SceneHelpers/ground/setGround": 19,
            "./SceneHelpers/materialHashMap/checkIfSwatchExists": 20,
            "./SceneHelpers/materialHashMap/getMaterialComponent": 21,
            "./SceneHelpers/materialHashMap/getSwatchIdForComponent": 22,
            "./SceneHelpers/materialHashMap/returnCountComponentsForSwatch": 23,
            "./SceneHelpers/materialHashMap/storeMaterial": 24,
            "./SceneHelpers/materials/createMaterial": 25,
            "./SceneHelpers/materials/updateCurrentShader": 26,
            "./SceneHelpers/materials/updateMaterial": 27,
            "./SceneHelpers/model/addSceneObjectToModel": 28,
            "./SceneHelpers/model/applyModelToScene": 29,
            "./SceneHelpers/model/changeModelMaterialSide": 30,
            "./SceneHelpers/model/cloneObject": 31,
            "./SceneHelpers/model/findChildrenByName": 32,
            "./SceneHelpers/model/getModel": 33,
            "./SceneHelpers/model/getModelComponents": 34,
            "./SceneHelpers/model/getModelName": 35,
            "./SceneHelpers/model/getModelPosition": 36,
            "./SceneHelpers/model/getScale": 37,
            "./SceneHelpers/model/isNotFlipped": 38,
            "./SceneHelpers/model/loadModel": 39,
            "./SceneHelpers/model/loadModelBySize": 40,
            "./SceneHelpers/model/parseModelComponents": 41,
            "./SceneHelpers/model/removeModelBySize": 42,
            "./SceneHelpers/model/replaceModel": 43,
            "./SceneHelpers/model/replaceModelComponents": 44,
            "./SceneHelpers/model/setComponentOptions": 45,
            "./SceneHelpers/model/setModel": 46,
            "./SceneHelpers/model/setModelComponentsVisibility": 47,
            "./SceneHelpers/model/setModelName": 48,
            "./SceneHelpers/model/setModelPosition": 49,
            "./SceneHelpers/model/setModelScale": 50,
            "./SceneHelpers/model/setNewModelComponents": 51,
            "./SceneHelpers/pdm/getPdm": 52,
            "./SceneHelpers/pdm/setPdm": 53,
            "./SceneHelpers/personalization/addTextCanvasToModel": 54,
            "./SceneHelpers/personalization/addTextToComponent": 55,
            "./SceneHelpers/personalization/calculateXCoordOffSet": 56,
            "./SceneHelpers/personalization/createGrid": 57,
            "./SceneHelpers/personalization/getTextCanvasTexture": 58,
            "./SceneHelpers/personalization/removePersonalizationObject": 59,
            "./SceneHelpers/productOptions/": 67,
            "./SceneHelpers/recipe/addProductOption": 77,
            "./SceneHelpers/recipe/checkForUGCComponent": 78,
            "./SceneHelpers/recipe/getRecipe": 79,
            "./SceneHelpers/recipe/hasProductOption": 80,
            "./SceneHelpers/recipe/removeProductOption": 81,
            "./SceneHelpers/recipe/setRecipe": 82,
            "./SceneHelpers/scene/getRootObject": 83,
            "./SceneHelpers/scene/getScene": 84,
            "./SceneHelpers/scene/getSceneCloneObjectByName": 85,
            "./SceneHelpers/scene/getSceneObjectByName": 86,
            "./SceneHelpers/scene/hideSceneObject": 87,
            "./SceneHelpers/scene/removeSceneObject": 88,
            "./SceneHelpers/scene/removeSceneObjectByName": 89,
            "./SceneHelpers/scene/returnMaterial": 90,
            "./SceneHelpers/scene/setRootObject": 91,
            "./SceneHelpers/scene/setScene": 92,
            "./SceneHelpers/scene/setSceneObjectMaterial": 93,
            "./SceneHelpers/scene/setSceneObjectMaterialSide": 94,
            "./SceneHelpers/scene/setSceneObjectVisibility": 95,
            "./SceneHelpers/scene/showSceneObject": 96,
            "./SceneHelpers/shaders/consumeShaders": 97,
            "./SceneHelpers/shaders/getUVType": 98,
            "./SceneHelpers/shaders/getUniform": 99,
            "./SceneHelpers/shaders/setUniform": 100,
            "./SceneHelpers/stitches/componentHasStitching": 101,
            "./SceneHelpers/stitches/returnStitchColor": 102,
            "./SceneHelpers/stitches/updateComponentStitching": 103,
            "./SceneHelpers/swatchMaterialGroups/applySwatchMaterialGroup": 104,
            "./SceneHelpers/swatchMaterialGroups/getSwatchMaterialGroupsData": 105,
            "./SceneHelpers/swatchMaterialGroups/overrideMeshOptions": 106,
            "./SceneHelpers/swatchMaterialGroups/setSwatchMaterialGroupsData": 107,
            "./SceneHelpers/swatchMaterialGroups/validateSwatchMaterialGroup": 108,
            "./SceneHelpers/swatches/applyColorMaterial": 109,
            "./SceneHelpers/swatches/applyMaterial": 110,
            "./SceneHelpers/swatches/applyShaders": 111,
            "./SceneHelpers/swatches/applySwatch": 112,
            "./SceneHelpers/swatches/applySwatchMaterialOptions": 113,
            "./SceneHelpers/swatches/changeSwatch": 114,
            "./SceneHelpers/swatches/getSwatch": 115,
            "./SceneHelpers/swatches/getSwatches": 116,
            "./SceneHelpers/swatches/meshMaterialOverride": 117,
            "./SceneHelpers/swatches/setSwatches": 118,
            "./SceneHelpers/swatches/updateMaterialOptions": 119,
            "./SceneHelpers/swatches/usingRecipe": 120,
            "./SceneHelpers/textures/addToCanvas": 121,
            "./SceneHelpers/textures/alphaTextureToTransparent": 122,
            "./SceneHelpers/textures/convertToNormalTexture": 123,
            "./SceneHelpers/textures/createCanvas": 124,
            "./SceneHelpers/textures/dispose": 125,
            "./SceneHelpers/textures/disposeMaterial": 126,
            "./SceneHelpers/textures/disposeMeshObject": 127,
            "./SceneHelpers/textures/disposeTexture": 128,
            "./SceneHelpers/textures/getDefaultTextures": 129,
            "./SceneHelpers/textures/getTextureFactory": 130,
            "./SceneHelpers/textures/getTextureLoader": 131,
            "./SceneHelpers/textures/loadFloorPassTexture": 132,
            "./SceneHelpers/textures/loadImage": 133,
            "./SceneHelpers/textures/loadMaps": 134,
            "./SceneHelpers/textures/loadMultipleTextures": 135,
            "./SceneHelpers/textures/loadTexture": 136,
            "./SceneHelpers/textures/loadTexturesApplyMaterials": 137,
            "./SceneHelpers/textures/returnAppliedTexture": 138,
            "./SceneHelpers/textures/returnOverrideTexturesList": 139,
            "./SceneHelpers/textures/saveAppliedTexture": 140,
            "./SceneHelpers/textures/setDefaultTextures": 141,
            "./SceneHelpers/textures/setTextureLoaderMode": 142
        } ],
        2: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.hex;
                return null !== this.returnHexComponent({
                    hex: t
                });
            };
        }, {} ],
        3: [ function(e, t, r) {
            "use strict";
            t.exports = function() {
                return this.hashMap;
            };
        }, {} ],
        4: [ function(e, t, r) {
            "use strict";
            t.exports = function() {
                return this.highlight_color;
            };
        }, {} ],
        5: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                delete this.materialHashMap[e], delete this.hashMap[e];
            };
        }, {} ],
        6: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                this.materialHashMap = {}, this.hashMap = {}, e && e();
            };
        }, {} ],
        7: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.hex, r = e.name, o = void 0 !== r && r, n = e.materialProperty, a = void 0 !== n && n;
                return this.checkHashMap({
                    hex: t
                }) ? this.returnSceneColorObj({
                    hex: t
                }) : this.setNewColorObj({
                    hex: t,
                    name: o,
                    materialProperty: a
                });
            };
        }, {} ],
        8: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var r = e.hex;
                if (!r) throw new Error("Invalid hex value");
                var o = this.getHashMap(), t = Object.keys(o).filter(function(e) {
                    var t = o[e].hex;
                    return (void 0 !== t && t) === r;
                });
                return t.length ? t[0] : null;
            };
        }, {} ],
        9: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.hex, r = this.returnHexComponent({
                    hex: t
                });
                if (!r) return null;
                var o = this.getHashMap()[r];
                if (o) {
                    var n = this.getSceneObjectByName({
                        objectName: r
                    });
                    return n.material[o.material_property] ? n.material[o.material_property] : new this.opts.THREE.Color(t);
                }
            };
        }, {} ],
        10: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.color;
                this.highlight_color = t;
            };
        }, {} ],
        11: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.hex, r = e.name, o = e.materialProperty;
                if (this.hashMap[r] || (this.hashMap[r] = {
                    hex: ""
                }), this.hashMap[r].hex !== t) {
                    var n = new this.opts.THREE.Color(t);
                    return this.hashMap[r] = {
                        hex: t,
                        material_property: o
                    }, n;
                }
            };
        }, {} ],
        12: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.geometry, r = e.attributeId, o = [], n = void 0 !== t.attributes.position ? t.attributes.position.array : void 0, a = void 0 !== t.attributes[r] ? t.attributes[r].array : t.attributes.uvs ? t.attributes.uvs.array : void 0;
                if (a && n) for (var i = 0; i < n.length / 3; i += 3) o.push([ {
                    x: a[2 * i],
                    y: a[2 * i + 1]
                }, {
                    x: a[2 * (i + 1)],
                    y: a[2 * (i + 1) + 1]
                }, {
                    x: a[2 * (i + 2)],
                    y: a[2 * (i + 2) + 1]
                } ]);
                return o;
            };
        }, {} ],
        13: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.geometry;
                function r(e, t) {
                    return e & 1 << t;
                }
                var o = {
                    faceVertexUvs: [],
                    faces: []
                }, n = void 0, a = void 0, i = void 0, s = t.faces, c = 0;
                if (void 0 !== t.uvs) {
                    for (var u = 0; u < t.uvs.length; ++u) t.uvs[u].length && c++;
                    for (var l = 0; l < c; ++l) o.faceVertexUvs[l] = [];
                }
                for (var p = 0, h = s.length; p < h; ) {
                    var m = s[p++], d = r(m, 0), f = r(m, 1), v = r(m, 3), g = r(m, 4), S = r(m, 5), x = r(m, 6), y = r(m, 7);
                    if (d) {
                        a = {
                            a: s[p],
                            b: s[p + 1],
                            c: s[p + 3]
                        }, i = {
                            a: s[p + 1],
                            b: s[p + 2],
                            c: s[p + 3]
                        }, p += 4, p += f ? 1 : 0;
                        var b = o.faces.length;
                        if (v) for (var M = 0; M < c; ++M) {
                            var w = t.uvs[M];
                            o.faceVertexUvs[M][b] = [], o.faceVertexUvs[M][b + 1] = [];
                            for (var H = 0; H < 4; ++H) {
                                var O = s[p++], T = {
                                    x: w[2 * O],
                                    y: w[2 * O + 1]
                                };
                                2 !== H && o.faceVertexUvs[M][b].push(T), 0 !== H && o.faceVertexUvs[M][b + 1].push(T);
                            }
                        }
                        p += g ? 1 : 0, p += S ? 4 : 0, p += x ? 1 : 0, p += y ? 4 : 0, o.faces.push(a), 
                        o.faces.push(i);
                    } else {
                        n = {
                            a: s[p++],
                            b: s[p++],
                            c: s[p++]
                        }, p += f ? 1 : 0;
                        var _ = o.faces.length;
                        if (v) for (var C = 0; C < c; ++C) {
                            var j = t.uvs[C];
                            o.faceVertexUvs[C][_] = [];
                            for (var N = 0; N < 3; ++N) {
                                var E = s[p++];
                                o.faceVertexUvs[C][_].push({
                                    x: j[2 * E],
                                    y: j[2 * E + 1]
                                });
                            }
                        }
                        p += g ? 1 : 0, p += S ? 3 : 0, p += x ? 1 : 0, p += y ? 3 : 0, o.faces.push(n);
                    }
                }
                return o.faceVertexUvs;
            };
        }, {} ],
        14: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.geometry, r = e.attributeId, o = this.opts.THREE, n = null;
                if (t.isGeometry) {
                    var a = t.clone();
                    n = new o.BufferGeometry().fromGeometry(a);
                    for (var i = a.faces, s = [], c = 0; c < a.faceVertexUvs.length; ++c) s.push([]);
                    for (var u = 0; u < i.length; ++u) for (var l = 0; l < a.faceVertexUvs.length; ++l) if (0 < a.faceVertexUvs[l].length) {
                        var p = a.faceVertexUvs[l][u];
                        void 0 !== p ? s[l].push(p[0], p[1], p[2]) : (console.warn("THREE.DirectGeometry.fromGeometry(): Undefined vertexUv ", u), 
                        s[l].push(new o.Vector2(), new o.Vector2(), new o.Vector2()));
                    }
                    for (var h = 0; h < a.faceVertexUvs.length; ++h) n.removeAttribute("uv" + (h + 1));
                    r = Number(r.replace("uv")), Number.isInteger(r) ? r-- : r = 0, 0 <= r && r < s.length && n.addAttribute("uv", new o.BufferAttribute(new Float32Array(2 * s[r].length), 2).copyVector2sArray(s[r]));
                } else {
                    var m = (n = t).getAttribute(r), d = m ? t.getAttribute(r).clone() : null, f = [];
                    for (var v in t.attributes) 0 === v.indexOf("uv") && f.push(v);
                    for (var g = 0; g < f.length; ++g) n.removeAttribute(f[g]);
                    m && (d.name = "uv", n.addAttribute(d.name, d));
                }
                return n;
            };
        }, {} ],
        15: [ function(e, t, r) {
            "use strict";
            t.exports = function(r, o) {
                var e = this.opts.THREE;
                if (e) {
                    (r = r || {}).trs = void 0 === r.trs || !!r.trs, r.onlyVisible = void 0 === r.onlyVisible || !!r.onlyVisible, 
                    r.truncateDrawRange = void 0 === r.truncateDrawRange || !!r.truncateDrawRange, r.binary = void 0 === r.binary || !!r.binary;
                    var t = {
                        model: r.model || null,
                        geostates: r.geostates || null
                    }, n = r.exporter ? r.exporter : e.GLTFExporter ? new e.GLTFExporter() : null;
                    if (!n) return o(new Error("GLTFExporter extension not found"));
                    this.simplifyModel(t, function(e, t) {
                        if (e) return o(e);
                        n.parse(t, function(e) {
                            o(null, e);
                        }, r);
                    });
                } else o(new Error("THREE was not defined"));
            };
        }, {} ],
        16: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var r = {};
                return e && e.traverse(function(t) {
                    [ "alphaMap", "aoMap", "bumpMap", "displacementMap", "emissiveMap", "envMap", "gradientMap", "lightMap", "map", "metalnessMap", "normalMap", "roughnessMap", "specularMap" ].forEach(function(e) {
                        t.material && t.material[e] && !r[t.material[e].uuid] && (r[t.material[e].uuid] = t.material[e]);
                    });
                }), this.loadMaps(r);
            };
        }, {} ],
        17: [ function(e, t, r) {
            "use strict";
            var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            };
            t.exports = function(e, t) {
                var x = this, r = e.model, o = e.geostates, y = this.opts.THREE, b = new y.Object3D(), M = this.getTextureFactory();
                if (!(r = r || this.getModel().getObjectByName(this.modelObjName) || this.getScene().getObjectByName(this.modelObjName))) return t(new Error("Model not defined"));
                var w = [], H = {}, O = new y.TextureLoader();
                b.scale.set(r.scale.x, r.scale.y, r.scale.z);
                var T = {};
                this.preloadAllModelTextures(r).then(function(S) {
                    r.traverse(function(e) {
                        e.isMesh && (T[e.name] = e);
                    }), o && "object" === (void 0 === o ? "undefined" : n(o)) && Object.keys(o).forEach(function(e) {
                        var t = o[e];
                        t.isMesh && (T[e] = t);
                    }), Object.keys(T).forEach(function(e) {
                        var t = T[e], a = t.clone();
                        a.material = new y.MeshStandardMaterial(), a.geometry = t.geometry.clone(), a.geometry.isBufferGeometry || x.ShaderMaterialService.ComponentShadersUpdates.updateUVAttributes(a), 
                        a.geometry.uuid = t.geometry.uuid, a.material.metalness = Math.max(t.material.reflectivity, 0) / 100, 
                        a.material.roughness = Math.max(100 - t.material.shininess, 0) / 100, b.add(a), 
                        a.visible = t.visible, a.material.visible = t.material.visible, a.material.color = t.material.color || null, 
                        a.material.transparent = t.material.transparent;
                        var i = t.material.map, r = t.material.bumpMap, s = t.material.alphaMap, o = t.material.normalMap, n = x.componentHasStitching({
                            componentName: e
                        }), c = !!x.checkForUGCComponent({
                            componentName: e
                        });
                        if (1 === t.material.alphaTest) a.visible = !1, a.material.visible = !1, a.material.transparent = !0, 
                        a.material.opacity = 0, a.geometry = x.simplifyUVAttributes({
                            geometry: a.geometry,
                            attributeId: "uv"
                        }); else if (i && S[i.uuid] && !n && ("uv3" === t.material.uvState || c)) {
                            var u = S[i.uuid].image, l = c ? [ 1, 1 ] : [ i.repeat.x, i.repeat.y ], p = x.createCanvas({
                                width: u.width,
                                height: u.height
                            });
                            if (M.render({
                                width: u.width,
                                height: u.height,
                                canvas: x.createCanvas({
                                    width: u.width,
                                    height: u.height
                                }),
                                buffers: [ {
                                    name: "a_position",
                                    type: "position",
                                    value: x.getUVsFromBufferGeometry({
                                        geometry: a.geometry,
                                        attributeId: "uv3"
                                    })
                                }, {
                                    name: "a_uv",
                                    type: "uvs",
                                    value: x.getUVsFromBufferGeometry({
                                        geometry: a.geometry,
                                        attributeId: "uv3"
                                    })
                                } ],
                                uniforms: [ {
                                    name: "u_repeat",
                                    type: "vec2",
                                    value: l
                                }, {
                                    name: "u_image_swatch",
                                    type: "texture",
                                    value: u
                                } ],
                                fragmentShaderSource: j.uv.fragmentShaderSource,
                                vertexShaderSource: j.uv.vertexShaderSource
                            }), x.addToCanvas(p, M.canvas, "webgl"), o) {
                                var h = S[o.uuid].image, m = x.createCanvas({
                                    width: h.width,
                                    height: h.height
                                });
                                M.render({
                                    width: h.width,
                                    height: h.height,
                                    canvas: x.createCanvas({
                                        width: h.width,
                                        height: h.height
                                    }),
                                    buffers: [ {
                                        name: "a_position",
                                        type: "position",
                                        value: x.getUVsFromBufferGeometry({
                                            geometry: a.geometry,
                                            attributeId: "uv3"
                                        })
                                    }, {
                                        name: "a_uv",
                                        type: "uvs",
                                        value: x.getUVsFromBufferGeometry({
                                            geometry: a.geometry,
                                            attributeId: "uv"
                                        })
                                    } ],
                                    uniforms: [ {
                                        name: "u_repeat",
                                        type: "vec2",
                                        value: [ i.repeat.x, i.repeat.y ]
                                    }, {
                                        name: "u_image_swatch",
                                        type: "texture",
                                        value: h
                                    } ],
                                    fragmentShaderSource: j.uv.fragmentShaderSource,
                                    vertexShaderSource: j.uv.vertexShaderSource
                                }), x.addToCanvas(m, M.canvas, "webgl");
                            }
                            a.geometry = x.simplifyUVAttributes({
                                geometry: a.geometry,
                                attributeId: "uv3"
                            }), w.push(new Promise(function(t, r) {
                                O.load(p.toDataURL(), function(e) {
                                    a.material.map = e, a.material.map.repeat.set(1, 1), t(e);
                                }, function(e) {
                                    console.error(e), r(e);
                                });
                            })), o && w.push(new Promise(function(t, r) {
                                O.load(normalMapComponentCanvas.toDataURL(), function(e) {
                                    a.material.normalMap = e, t(e);
                                }, function(e) {
                                    console.error(e), r(e);
                                });
                            }));
                        } else if (r && S[r.uuid] && n) {
                            var d = t.clone();
                            d.material = new y.MeshStandardMaterial(), d.material.metalness = 0, d.material.roughness = 1, 
                            d.material.visible = t.material.visible, d.visible = t.visible, d.geometry = t.geometry.clone(), 
                            d.name = e + "_stitches", d.geometry = x.simplifyUVAttributes({
                                geometry: d.geometry,
                                attributeId: "uv2"
                            }), d.geometry.uuid = t.geometry.uuid + "_clone", b.add(d);
                            var f = S[r.uuid].image;
                            H[r.uuid] || (H[r.uuid] = {
                                bumpMap: f,
                                components: []
                            }), H[r.uuid].components[e] = d;
                            var v = o ? S[o.uuid].image : null, g = o ? x.createCanvas({
                                width: v.width,
                                height: v.height
                            }) : null;
                            o && c && i && (M.render({
                                width: v.width,
                                height: v.height,
                                canvas: x.createCanvas({
                                    width: v.width,
                                    height: v.height
                                }),
                                buffers: [ {
                                    name: "a_position",
                                    type: "position",
                                    value: x.getUVsFromBufferGeometry({
                                        geometry: a.geometry,
                                        attributeId: "uv3"
                                    })
                                }, {
                                    name: "a_uv",
                                    type: "uvs",
                                    value: x.getUVsFromBufferGeometry({
                                        geometry: a.geometry,
                                        attributeId: "uv"
                                    })
                                } ],
                                uniforms: [ {
                                    name: "u_repeat",
                                    type: "vec2",
                                    value: [ i.repeat.x, i.repeat.y ]
                                }, {
                                    name: "u_image_swatch",
                                    type: "texture",
                                    value: v
                                } ],
                                fragmentShaderSource: j.uv.fragmentShaderSource,
                                vertexShaderSource: j.uv.vertexShaderSource
                            }), x.addToCanvas(g, M.canvas, "webgl")), a.geometry = x.simplifyUVAttributes({
                                geometry: a.geometry,
                                attributeId: c ? "uv3" : "uv"
                            }), w.push(new Promise(function(e, t) {
                                i && S[i.uuid] ? (a.material.map = _(i), c && a.material.map.repeat.set(1, 1)) : a.material.map = null, 
                                o && (a.material.normalMap = _(o)), C(a, "uv"), e();
                            })), o && c && w.push(new Promise(function(t, r) {
                                O.load(g.toDataURL(), function(e) {
                                    a.material.normalMap = e, t(e);
                                }, function(e) {
                                    console.error(e), r(e);
                                });
                            }));
                        } else s && S[s.uuid] && i && S[i.uuid] ? w.push(new Promise(function(t, r) {
                            var e = S[s.uuid].image, o = S[i.uuid].image, n = x.createCanvas({
                                width: e.width,
                                height: e.height
                            });
                            M.render({
                                width: e.width,
                                height: e.height,
                                canvas: x.createCanvas({
                                    width: e.width,
                                    height: e.height
                                }),
                                buffers: [ {
                                    name: "a_position",
                                    type: "position",
                                    itemSize: 2,
                                    value: x.getUVsFromBufferGeometry({
                                        geometry: a.geometry,
                                        attributeId: "uv"
                                    })
                                }, {
                                    name: "a_uv",
                                    type: "uvs",
                                    itemSize: 2,
                                    value: x.getUVsFromBufferGeometry({
                                        geometry: a.geometry,
                                        attributeId: "uv"
                                    })
                                } ],
                                uniforms: [ {
                                    name: "u_image_alpha",
                                    type: "texture",
                                    value: e
                                }, {
                                    name: "u_image_map",
                                    type: "texture",
                                    value: o
                                } ],
                                fragmentShaderSource: j.alphaColored.fragmentShaderSource,
                                vertexShaderSource: j.alphaColored.vertexShaderSource
                            }), x.addToCanvas(n, M.canvas, "webgl"), O.load(n.toDataURL(), function(e) {
                                a.material.map = e, a.material.map.repeat = s.repeat, a.material.map.offset = s.offset, 
                                t(e);
                            }, function(e) {
                                console.error(e), r(e);
                            });
                        })) : s && S[s.uuid] ? w.push(new Promise(function(t, r) {
                            var e = x.alphaTextureToTransparent(S[s.uuid].image);
                            O.load(e.toDataURL(), function(e) {
                                a.material.map = e, a.material.map.repeat = s.repeat, a.material.map.offset = s.offset, 
                                a.material.transparent = !0, t(e);
                            }, function(e) {
                                console.error(e), r(e);
                            });
                        })) : i && S[i.uuid] ? (a.material.map = _(i), C(a, "uv")) : o && S[o.uuid] ? (a.material.normalMap = _(o), 
                        C(a, "uv")) : a.material.map = null, a.geometry = x.simplifyUVAttributes({
                            geometry: a.geometry,
                            attributeId: "uv"
                        });
                    }), Promise.all(w).then(function() {
                        t(null, b);
                    }).catch(function(e) {
                        console.error("texturePromises ERROR", e), t(e);
                    });
                });
            };
            var _ = function(e) {
                var t = e.clone();
                return t.uuid = e.uuid, t;
            }, C = function(e, t) {
                if (e && e.geometry.getAttribute(t)) for (var r = e.geometry.getAttribute(t).array, o = 0; o < r.length; o += 2) r[o + 1] *= -1;
            }, j = {
                uv: {
                    vertexShaderSource: "precision mediump float;\nattribute vec2 a_position;\nattribute vec2 a_uv;\nuniform vec2 u_resolution;\nvarying vec2 v_uv;\n\nvoid main() {\n  vec2 zeroToOne = a_position / u_resolution; // convert the rectangle from pixels to 0.0 to 1.0\n  vec2 zeroToTwo = zeroToOne * 2.0; // convert from 0->1 to 0->2\n  vec2 clipSpace = zeroToTwo - 1.0; // convert from 0->2 to -1->+1 (clipspace)\n  gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);\n\n  // pass the texCoord to the fragment shader\n  // The GPU will interpolate this value between points.\n  v_uv = a_uv;\n}\n",
                    fragmentShaderSource: "precision mediump float;\nuniform sampler2D u_image_swatch;\nuniform vec2 u_repeat;\nvarying vec2 v_uv;\n\nvoid main() {\n  vec4 colorSwatch = texture2D( u_image_swatch, fract(v_uv * u_repeat) );\n  gl_FragColor = colorSwatch;\n}\n"
                },
                alphaColored: {
                    vertexShaderSource: "precision mediump float;\nattribute vec2 a_position;\nattribute vec2 a_uv;\nuniform vec2 u_resolution;\nvarying vec2 v_uv;\n\nvoid main() {\n  vec2 zeroToOne = a_position / u_resolution; // convert the rectangle from pixels to 0.0 to 1.0\n  vec2 zeroToTwo = zeroToOne * 2.0; // convert from 0->1 to 0->2\n  vec2 clipSpace = zeroToTwo - 1.0; // convert from 0->2 to -1->+1 (clipspace)\n  gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);\n\n  // pass the texCoord to the fragment shader\n  // The GPU will interpolate this value between points.\n  v_uv = a_uv;\n}\n",
                    fragmentShaderSource: "precision mediump float;\nuniform sampler2D u_image_map;\nuniform sampler2D u_image_alpha;\nvarying vec2 v_uv;\n\nvoid main() {\n  vec4 colorMapTex = texture2D( u_image_map, v_uv );\n  vec4 colorAlphaTex = texture2D( u_image_alpha, v_uv );\n  gl_FragColor = vec4(colorMapTex.r, colorMapTex.g, colorMapTex.b, 0.2126 * colorAlphaTex.r + 0.7152 * colorAlphaTex.g + 0.0722 * colorAlphaTex.b);\n}\n"
                }
            };
        }, {} ],
        18: [ function(e, t, r) {
            "use strict";
            t.exports = function() {
                return this.ground;
            };
        }, {} ],
        19: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.ground;
                this.ground = t;
            };
        }, {} ],
        20: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.swatchId;
                return null !== this.getMaterialComponent({
                    swatchId: t
                });
            };
        }, {} ],
        21: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = this, r = e.swatchId, o = null;
                return Object.keys(this.materialHashMap).forEach(function(e) {
                    if (t.materialHashMap[e] === r) return o = e, !1;
                }), o;
            };
        }, {} ],
        22: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.componentName;
                return this.materialHashMap[t] || null;
            };
        }, {} ],
        23: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = this, r = e.swatchId, o = 0;
                return Object.keys(this.materialHashMap).forEach(function(e) {
                    t.materialHashMap[e] === r && ++o;
                }), o;
            };
        }, {} ],
        24: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.swatchId, r = e.componentName;
                if (!t || !r) throw new Error("Invalid params");
                this.materialHashMap[r] = t;
            };
        }, {} ],
        25: [ function(e, t, r) {
            "use strict";
            var d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            };
            t.exports = function(e) {
                var t = e.mesh_type, r = void 0 === t ? "MeshStandardMaterial" : t, o = e.options, n = void 0 === o ? {} : o, a = e.componentName, i = e.shadersType, s = this, c = this.opts.THREE, u = null, l = this.enableCustomShaders, p = l ? s.ShaderMaterialService.getShaders() : null;
                i && p && (u = p[i] || p.default), l && "string" == typeof i && !p[i] && "object" !== d(p[i]) && console.warn("Cannot find a set of shaders by the specified name '" + i + "' for the component '" + a + "'"), 
                a && n.emissive && (n.emissive = new c.Color(n.emissive));
                var h = {
                    stitchColor: {
                        type: "c",
                        value: n.color ? n.color instanceof c.Color ? n.color : new c.Color(n.color) : new c.Color(1, 1, 1)
                    },
                    highLightColor: {
                        type: "c",
                        value: new c.Color(s.getHighlightColor())
                    },
                    highLightAlpha: {
                        type: "f",
                        value: 0
                    },
                    useHighLight: {
                        type: "i",
                        value: 0
                    },
                    normalRepeat: {
                        type: "f",
                        value: 1
                    }
                }, m = {};
                return l || "uv3" === i ? ((m = s.ShaderMaterialService.MaterialBuilderFactory.createMaterial({
                    meshType: r,
                    options: n,
                    shaders: u,
                    uniforms: h
                })).isCustomsShaderMaterial = !0, m.shaderSet = i) : (m = new c[r](n), m = s.updateCurrentShader({
                    material: m,
                    uniforms: h
                }), s.updateMaterial({
                    material: m,
                    options: n
                })), m;
            };
        }, {} ],
        26: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var r = e.material, o = e.uniforms, n = this.opts.THREE;
                return r.onBeforeCompile = function(e) {
                    e.uniforms = Object.assign(e.uniforms, o);
                    var t = n.ShaderChunk.normal_fragment_maps.replace("vec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;", "vec3 mapN = texture2D( normalMap, normalRepeat * vUv ).xyz * 2.0 - 1.0;");
                    e.fragmentShader = e.fragmentShader.replace("#include <common>", "\n        #include <common>\n        uniform bool useHighLight;\n        uniform float highLightAlpha;\n        uniform vec3 highLightColor;\n        uniform float normalRepeat;\n        uniform vec3 stitchColor;\n        ").replace("#include <dithering_fragment>", "\n        #include <dithering_fragment>\n        if (useHighLight) {\n          gl_FragColor.rgb = mix(gl_FragColor.rgb, highLightColor, highLightAlpha);\n        }\n        ").replace("#include <normal_fragment_maps>", t), 
                    r.userData.shader = e;
                }, r.transparent = !0, r.needsUpdate = !0, r;
            };
        }, {} ],
        27: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.material, r = e.options, o = this.opts.THREE;
                if (t && r) {
                    var n = new o.TextureLoader();
                    [ "bumpScale", "metalness", "opacity", "reflectivity", "roughness", "shininess", "transparent" ].forEach(function(e) {
                        r[e] && void 0 !== r[e] && (t[e] = r[e]);
                    });
                    [ "map", "alphaMap", "aoMap", "bumpMap", "lightMap", "normalMap", "roughnessMap", "specularMap" ].forEach(function(e) {
                        r[e] && void 0 !== r[e] && (t[e] = "string" == typeof r[e] ? n.load(r[e]) : r[e]);
                    });
                    [ "color", "emissive", "specular" ].forEach(function(e) {
                        r[e] && void 0 !== r[e] && (t[e] = "string" == typeof r[e] ? new o.Color(r[e]) : r[e]);
                    }), r.blending && void 0 !== r.blending && (t.blending = "string" == typeof r.blending ? o[r.blending] : r.blending), 
                    r.normalScale && void 0 !== r.normalScale && (t.normalScale = t.normalScale instanceof Array ? new o.Vector2(r.normalScale[0], r.normalScale[1]) : t.normalScale);
                }
                return t;
            };
        }, {} ],
        28: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.objectToAdd, r = this.getModel();
                if (r) return r.add(t), this.getModelComponents()[t.name] = t, r.getObjectByName(t.name);
                throw new Error("The object with name " + t.name + " could not be added");
            };
        }, {} ],
        29: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var o = this, n = e.model, a = e.size;
                return new Promise(function(e, t) {
                    var r = o.getPdm().sku;
                    n.position.set(0, 0, 0), o.loadModelAssets({
                        model: n
                    }), o.setComponentGroups(), o.removeModelBySize({
                        sku: r,
                        modelObj: modelObj,
                        size: a
                    }), that.rootObj.add(modelObj), that.modelObjName = r + "-" + a, modelObj.name = r + "-" + a, 
                    sceneHelpers.setModel({
                        model: modelObj
                    }), that.stitching.init(that.stitches), that.sceneManager.loadModelAssets(that.productSKU, modelObj), 
                    that.setComponentGroups(), that.sceneManager.setupModelDefaults(modelObj), that.applyRecipe(), 
                    that.productOptions2.visibility.applyFromRecipe(), deferred.resolve(modelObj);
                });
            };
        }, {} ],
        30: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.materialSide, r = this.getModelComponents();
                if (r) for (var o in r) r[o].material && (r[o].material.side = t);
            };
        }, {} ],
        31: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.objectNameToClone, r = e.options, o = this.getModel();
                if (o) {
                    var n = o.getObjectByName(t).clone();
                    if (t) return r && Object.keys(r).forEach(function(e) {
                        n[e] = r[e];
                    }), n;
                }
                return null;
            };
        }, {} ],
        32: [ function(e, t, r) {
            "use strict";
            t.exports = function(e, t) {
                return o(e, t);
            };
            var o = function e(t, r) {
                var o = null;
                if (t && t.children) for (var n = 0; n < t.children.length && null === o; ++n) o = t.children[n].name === r ? t.children[n] : e(t.children[n], r);
                return o;
            };
        }, {} ],
        33: [ function(e, t, r) {
            "use strict";
            t.exports = function() {
                return this.model;
            };
        }, {} ],
        34: [ function(e, t, r) {
            "use strict";
            t.exports = function() {
                return this.modelComponents;
            };
        }, {} ],
        35: [ function(e, t, r) {
            "use strict";
            t.exports = function() {
                return this.modelName;
            };
        }, {} ],
        36: [ function(e, t, r) {
            "use strict";
            t.exports = function() {
                var e = this.getModel();
                return e ? e.position : null;
            };
        }, {} ],
        37: [ function(e, t, r) {
            "use strict";
            t.exports = function() {
                var e = this.getModel();
                return e ? e.scale : null;
            };
        }, {} ],
        38: [ function(e, t, r) {
            "use strict";
            t.exports = function() {
                var e = this.getModel();
                return !!e && 0 <= e.scale.z;
            };
        }, {} ],
        39: [ function(e, t, r) {
            "use strict";
            var c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            };
            t.exports = function(e) {
                var n = this, a = e.path, i = e.json, s = new this.opts.THREE.ObjectLoader();
                return new Promise(function(t, r) {
                    try {
                        if ("string" == typeof a) s.load(a, function(e) {
                            n.setModel({
                                model: e.children[0]
                            }), t(e);
                        }, null, r); else if (i && "object" === (void 0 === i ? "undefined" : c(i))) {
                            var e = s.parse(i), o = e.children[0];
                            o.uuid = i.object.uuid, o.traverse(function(e) {
                                if (e && e.geometry) {
                                    n.ShaderMaterialService.ComponentShadersUpdates.updateUVAttributes(e);
                                    var t = n.findChildrenByName(i.object, e.name);
                                    t && t.geometry && (e.geometry.uuid = t.geometry);
                                }
                            }), n.setModel({
                                model: o
                            }), t(e);
                        } else r(new Error("Not found the Path to the model or JSON model"));
                    } catch (e) {
                        r(e);
                    }
                });
            };
        }, {} ],
        40: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var o = e.size, t = e.path, n = void 0 !== t && t, r = e.json, a = void 0 !== r && r;
                return this.resetHashData(), new Promise(function(r, t) {
                    this.loadModel({
                        path: n,
                        json: a
                    }).then(function(e) {
                        return this.applyModelToScene({
                            model: e,
                            size: o
                        });
                    }).then(function() {
                        return this.loadFloorPassTexture({
                            sku: this.getPdm().sku,
                            modelSize: o
                        });
                    }).then(function(e) {
                        var t = this.getGround();
                        this.dispose(t.material.map), t.material.map = e, r();
                    }).catch(function(e) {
                        console.error(e), t(e);
                    });
                });
            };
        }, {} ],
        41: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = this, r = !(1 < arguments.length && void 0 !== arguments[1]) || arguments[1], o = this.opts.THREE;
                e || (e = this.getModel());
                var n = {};
                return e && (e.traverse(function(e) {
                    e instanceof o.Mesh && (r && (e.name = e.name.toLowerCase()), n[e.name] = e, t.ShaderMaterialService.ComponentShadersUpdates.updateUVAttributes(e));
                }), this.replaceModelComponents({
                    newModelComponents: n
                })), n;
            };
        }, {} ],
        42: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var r = e.sku, t = (e.modelObj, e.size), o = void 0, n = this;
                if (n.modelBySize.length) {
                    var a = n.opts.THREE, i = n.getRootObject();
                    this.modelBySize.forEach(function(e) {
                        if (o = n.getSceneObjectByName({
                            objectName: r + "-" + e
                        })) {
                            o.traverse(function(e) {
                                e instanceof a.Mesh ? n.disposeMeshObject({
                                    meshObject: e
                                }) : -1 < e.name.indexOf("clone") && n.disposeMeshObject({
                                    meshObject: e.children[0]
                                });
                            }), i.remove(o);
                            var t = n.modelBySize.indexOf(e);
                            -1 < t && n.modelBySize.splice(t, 1);
                        }
                    });
                }
                n.modelBySize.push(t);
            };
        }, {} ],
        43: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.newModel, r = this.getModel(), o = this.getRootObject();
                r && o.remove(r), o.add(t), this.setModel({
                    model: t
                });
            };
        }, {} ],
        44: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.newModelComponents;
                this.modelComponents = null, this.setNewModelComponents({
                    modelComponents: t
                });
            };
        }, {} ],
        45: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.component, r = e.options;
                return t && r && Object.keys(r).forEach(r, function(e) {
                    t[e] = r[e];
                }), t;
            };
        }, {} ],
        46: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.model;
                return this.model && (this.model = null), this.model = t;
            };
        }, {} ],
        47: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var o = this, n = e.pdm, a = this.getModelComponents();
                if (!a) throw new Error("There are not model components in " + modelName);
                n || (n = this.getPdm()), Object.keys(a).forEach(function(e) {
                    var t = a[e], r = t.name;
                    n.components[r] && o.setSceneObjectVisibility({
                        componentName: r,
                        visible: n.components[t.name].visible
                    });
                });
            };
        }, {} ],
        48: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.modelName;
                return this.modelName = t;
            };
        }, {} ],
        49: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.x, r = e.y, o = e.z, n = this.getModel();
                if (n) return n.position.set(t, r, o);
                throw new Error("The model " + modelName + " could not set position");
            };
        }, {} ],
        50: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.scale, r = this.getModel();
                if (r) {
                    var o = t.x, n = t.y, a = t.z;
                    return r.scale.set(o, n, a);
                }
                throw new Error("The scale could not be set");
            };
        }, {} ],
        51: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.modelComponents;
                this.modelComponents = t;
            };
        }, {} ],
        52: [ function(e, t, r) {
            "use strict";
            t.exports = function() {
                return this.pdm;
            };
        }, {} ],
        53: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.pdm;
                return this.pdm = t;
            };
        }, {} ],
        54: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                e.modelComponents;
                var t = e.textcanvas, r = e.textcolor, o = e.personalizationComponent, n = e.view, a = this.opts.THREE, i = new a.Object3D(), s = this.getSceneObjectByName({
                    objectName: o
                }).clone();
                i.location = o, this.serverSide ? (s.uuid = "Textobj_" + n, i.name = "Textobj_" + n) : (s.uuid = "Textobj", 
                i.name = "Textobj"), i.add(s);
                var c = {
                    emissive: new a.Color(r),
                    transparent: !0,
                    map: t
                };
                return s.material = new a.MeshStandardMaterial(c), this.addSceneObjectToModel({
                    objectToAdd: i
                }), i;
            };
        }, {} ],
        55: [ function(e, t, r) {
            "use strict";
            t.exports = function(e, t) {
                var r = this, o = e.debug, n = e.personalizationPdm, a = e.personalizationRecipe, i = e.personalizationPositioning, s = e.recipeId, c = void 0 === s ? "" : s, u = e.personalizationComponent, l = void 0 === u ? "" : u, p = a.clone_dimensions, h = this.canvasFactory();
                h.width = p[0], h.heigth = p[1];
                var m = h.getContext("2d");
                if (m.fillStyle = "rgba(0, 0, 0, 1)", m.textAlign = "left", this.serverSide ? "franklin-gothic-urw-cond" == textfont ? m.font = "bold italic " + a.fontSize + " FranklinGothic" : ("Helvetica Neue" == textfont || textfont, 
                m.font = "bold italic " + a.fontSize + " LiberationSans") : m.font = a.font_options + " " + a.fontSize + " " + a.font, 
                n.transform) {
                    var d = n.transform, f = d.a, v = d.b, g = d.c, S = d.d, x = d.e, y = d.f;
                    m.transform(f, v, g, S, x, y);
                }
                n.rotate && m.rotate(n.rotate);
                var b = i || n.positioning, M = a.text.toUpperCase(), w = a.image_views.view, H = this.calculateXCoordOffSet({
                    coeficient: M.length
                }), O = b.canvasX - H, T = b.canvasY;
                -1 < w.indexOf("left") && (m.scale(-1, 1), O -= 1024), o && this.createGrid({
                    context: m
                }), m.fillText(M, O, T), this.getTextCanvasTexture({
                    canvas: h,
                    textureSettings: n.texture_settings,
                    recipeId: c,
                    view: w,
                    text: M,
                    personalizationComponent: l
                }).then(function(e) {
                    r.addTextCanvasToModel({
                        texture: e
                    }), t();
                }).catch(t);
            };
        }, {} ],
        56: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.font_size, r = e.config, o = e.coeficient, n = parseInt(t, 10), a = .5;
                if (o < 1) throw new Error("Invalid coeficient argument. Number must be higher that 0.");
                return 1 === o ? 0 : (r && r[o - 1] && (a = r[o - 1]), .5 * o * n * a);
            };
        }, {} ],
        57: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.context;
                if (t && t.fillText) {
                    for (var r = -1e3; r <= 1e3; r += 50) {
                        for (var o = "" + r, n = 1; n <= 100; n++) o = o + " " + r;
                        t.fillText(o, 0, r);
                    }
                    return t;
                }
            };
        }, {} ],
        58: [ function(m, e, t) {
            "use strict";
            e.exports = function(e) {
                var s = this, c = e.canvas, u = e.textureSettings, t = e.recipeId, l = void 0 === t ? "" : t, r = e.view, p = void 0 === r ? "" : r, o = e.text, h = void 0 === o ? "" : o;
                e.personalizationComponent;
                return new Promise(function(r, o) {
                    var e = s.opts.THREE;
                    if (s.serverSide) {
                        var n = m("fs"), a = c.toBuffer(), i = s.tmpImageDir + "/personalization-images/" + l + "-" + p + "-" + h + "-label.png";
                        n.open(i, "w+", function(e, t) {
                            if (e) return cb(new Error("ApplyText, fs.open error: " + e));
                            n.write(t, a, 0, a.length, function(e) {
                                if (e) return cb(new Error("applyText, fs.write error: " + e));
                                s.loadTexture({
                                    path: i,
                                    options: u || null
                                }).then(function(e) {
                                    u && u.repeat || e.repeat.set(1, 1), r(e);
                                }).catch(function(e) {
                                    o(new Error("Unable to load texture " + i + ": " + e));
                                });
                            });
                        });
                    } else try {
                        var t = new e.Texture(c);
                        u && (u.wrapS ? t.wrapS = e[u.wrapS] : t.wrapS = e.RepeatWrapping, u.wrapT ? t.wrapT = e[u.wrapS] : t.wrapT = e.RepeatWrapping, 
                        u.repeat && t.repeat.set(Number(u.repeat[0]), Number(u.repeat[1]))), r(t);
                    } catch (e) {
                        o(e);
                    }
                });
            };
        }, {
            fs: 145
        } ],
        59: [ function(e, t, r) {
            "use strict";
            t.exports = function(e, t) {
                var r = e.model;
                r || (r = this.getModel());
                try {
                    for (var o = r.children.length - 1; 0 <= o; o--) -1 < r.children[o].name.indexOf("Textobj") && this.removeSceneObject(r.children[o]);
                    return t();
                } catch (e) {
                    return t(e);
                }
            };
        }, {} ],
        60: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var i = this, t = e.productOption, s = e.geoStateObj, r = e.componentName, c = this.getRecipe(), o = t.options.states.on.componentsToRemove;
                return Promise.all(Object.keys(s).map(function(a) {
                    return new Promise(function(o, n) {
                        var e = s[a], t = i.ShaderMaterialService.MaterialHelpers.hasSwatchUV(i.getSceneObjectByName({
                            objectName: a
                        })), r = c.components[a] && c.components[a].ugc;
                        return r && t ? o() : (r && !t && console.info("WARNING: Component '" + a + "' have not a UV3 attributes of geometry. Used geo-states."), 
                        i.productOptions.geostates.applyToModel({
                            obj: e,
                            geoComponentName: a
                        }) ? void i.updateComponentStitching({
                            componentName: a
                        }, function(e) {
                            if (e) return n(e);
                            var t = c.components[a];
                            if (!t) return o();
                            var r = t.swatch_id;
                            i.changeSwatch({
                                swatchID: r,
                                componentName: a
                            }, function(e) {
                                if (e) return n(new Error("Unable to change swatch " + r + " for " + a + ": " + e));
                                o();
                            });
                        }) : n(new Error("There was an error adding geostate of " + a)));
                    });
                })).then(function() {
                    if (o && 0 < o.length && !i.productOptions.geostates.removeDisabledComponents({
                        componentsToRemove: o
                    })) throw new Error("There was an issue removing components of geostates in " + r);
                    return Promise.resolve();
                });
            };
        }, {} ],
        61: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.geoComponentName, r = e.obj;
                try {
                    var o = this.getSceneObjectByName({
                        objectName: t
                    }), n = void 0, a = void 0;
                    o && (n = o.material, a = o.group_parent, this.removeSceneObject(o), this.removeSceneObjectByName(t + "_clone")), 
                    this.addSceneObjectToModel({
                        objectToAdd: r
                    });
                    var i = this.getSceneObjectByName({
                        objectName: t
                    });
                    return n && (i.material = n), a && (i.group_parent = a), !0;
                } catch (e) {
                    return console.error(e), !1;
                }
            };
        }, {} ],
        62: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var a = this, i = e.geoOptions, s = e.geoComponentName, r = e.modelName, o = (e.textures, 
                e.size), c = i.geometry;
                return new Promise(function(n, e) {
                    if (!c) return e(new Error("There is not geometry value in geostates for  " + s));
                    var t = a.modelsPath + "/" + r + "/" + (o || "") + c;
                    console.log("geostateJsonPath", t), a.productOptions.geostates.parseJson({
                        geoComponentName: s,
                        path: t
                    }).then(function(e) {
                        var t = i.mesh_options, r = i.mesh_type;
                        if (t) {
                            r || (r = a.getSceneObjectByName({
                                objectName: s
                            }).material.type);
                            var o = a.getUVType({
                                componentName: s
                            });
                            e.material = a.createMaterial({
                                mesh_type: r,
                                options: t,
                                componentName: s,
                                shadersType: o
                            }), e.material.uvState = o;
                        }
                        n(e);
                    }).catch(e);
                });
            };
        }, {} ],
        63: [ function(e, t, r) {
            "use strict";
            var o = e("./addGeostatesToModel"), n = e("./applyToModel"), a = e("./get3dObject"), i = e("./loadGeostates"), s = e("./parseJson"), c = e("./removeDisabledComponents");
            t.exports = function(e) {
                var t = e || this;
                return {
                    addGeostatesToModel: o.bind(t),
                    applyToModel: n.bind(t),
                    get3dObject: a.bind(t),
                    loadGeostates: i.bind(t),
                    parseJson: s.bind(t),
                    removeDisabledComponents: c.bind(t)
                };
            };
        }, {
            "./addGeostatesToModel": 60,
            "./applyToModel": 61,
            "./get3dObject": 62,
            "./loadGeostates": 64,
            "./parseJson": 65,
            "./removeDisabledComponents": 66
        } ],
        64: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var n = this, t = e.productOption, a = e.size, i = (e.componentName, e.textures), s = e.modelName, c = {}, u = t.options.states.on.components;
                return new Promise(function(e, t) {
                    try {
                        Promise.all(Object.keys(u).map(function(o) {
                            return new Promise(function(t, e) {
                                var r = u[o];
                                n.productOptions.geostates.get3dObject({
                                    geoOptions: r,
                                    geoComponentName: o,
                                    modelName: s,
                                    textures: i,
                                    size: a
                                }).then(function(e) {
                                    c[o] = e, t();
                                }).catch(e);
                            });
                        })).then(function() {
                            e(c);
                        }).catch(t);
                    } catch (e) {
                        return t(e);
                    }
                });
            };
        }, {} ],
        65: [ function(e, t, r) {
            "use strict";
            var c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            };
            t.exports = function(e) {
                var o = this, r = e.geoComponentName, n = e.path, a = e.json, i = this.opts.THREE, s = new i.ObjectLoader();
                return new Promise(function(t, r) {
                    try {
                        if ("string" == typeof n) s.load(n, function(e) {
                            t(e);
                        }, null, r); else if (a && "object" === (void 0 === a ? "undefined" : c(a))) {
                            var e = s.parse(a);
                            e.traverse(function(e) {
                                if (e && e.geometry) {
                                    o.ShaderMaterialService.ComponentShadersUpdates.updateUVAttributes(e);
                                    var t = o.findChildrenByName(a.object, e.name);
                                    t && t.geometry && (e.geometry.uuid = t.geometry);
                                }
                            }), t(e);
                        } else r(new Error("Not found the Path to the JSON object"));
                    } catch (e) {
                        r(e);
                    }
                }).then(function(e) {
                    var t = e.getObjectByName(r);
                    return t.name = r, o.ShaderMaterialService && t.traverse(function(e) {
                        e instanceof i.Mesh && o.ShaderMaterialService.ComponentShadersUpdates.updateUVAttributes(e);
                    }), Promise.resolve(t);
                });
            };
        }, {} ],
        66: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var r = this, t = e.componentsToRemove;
                try {
                    return t.forEach(function(e) {
                        var t = r.getSceneObjectByName({
                            objectName: e
                        });
                        t && (r.disposeMeshObject({
                            meshObject: t
                        }), r.removeSceneObjectByName(e), r.removeSceneObjectByName(e + "_clone"));
                    }), !0;
                } catch (e) {
                    return console.error(e), !1;
                }
            };
        }, {} ],
        67: [ function(e, t, r) {
            "use strict";
            var o = e("./main/getProductOptionByProperty"), n = e("./main/getProductOptionsFromRecipe"), a = e("./main/isValid"), i = e("./planeGeo"), s = e("./geostates");
            t.exports = function(e) {
                var t = e || this;
                return {
                    getProductOptionByProperty: o.bind(t),
                    getProductOptionsFromRecipe: n.bind(t),
                    isValid: a.bind(t),
                    planeGeo: i(t),
                    geostates: s(t)
                };
            };
        }, {
            "./geostates": 63,
            "./main/getProductOptionByProperty": 68,
            "./main/getProductOptionsFromRecipe": 69,
            "./main/isValid": 70,
            "./planeGeo": 75
        } ],
        68: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var r = e.property, o = e.name, n = this, a = {};
                return Object.keys(n.productOptionsItems).forEach(function(e) {
                    var t = n.productOptionsItems[e];
                    t.path = e, t[r] && t[r] === o ? a = t : t.options[r] && t.options[r] === o && (a = t);
                }), a;
            };
        }, {} ],
        69: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.recipe;
                if (t && t.components) {
                    var r = {};
                    return Object.keys(t.components).forEach(function(e) {
                        t.components[e].product_option && (r[e] = t.components[e].product_option);
                    }), r;
                }
                throw new Error("Unable to parse from recipe");
            };
        }, {} ],
        70: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.sku, r = e.componentName, o = e.productOption;
                if (!o.options) return !1;
                var n = o.rules || o.options.rules;
                if (!n) return !1;
                if (!(Array.isArray(n.models) && 0 <= n.models.indexOf(t))) return !1;
                var a = Array.isArray(n.components) && 0 <= n.components.indexOf(r), i = o.behavior || o.options.behavior;
                return a || i === this.TOGGLE_BEHAVIOR;
            };
        }, {} ],
        71: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var c = e.productOption, u = this, l = this.opts.THREE;
                return new Promise(function(t, e) {
                    var r = new l.PlaneGeometry(c.size.width, c.size.height), o = new l.MeshBasicMaterial({
                        side: l[c.side]
                    }), n = new l.Mesh(r, o);
                    n.name = c.componentName, u.addSceneObjectToModel({
                        objectToAdd: n
                    });
                    var a = u.getSceneObjectByName({
                        objectName: c.componentName
                    });
                    a.position.set(c.position.x, c.position.y, c.position.z), c.rotation.x && a.rotateX(c.rotation.x), 
                    c.rotation.y && a.rotateY(c.rotation.y), c.rotation.z && a.rotateZ(c.rotation.z), 
                    a.material.color = new l.Color(c.init_color);
                    var i = c.texture[0], s = u.s3_base + i.image_url;
                    u.loadTexture({
                        path: s,
                        options: i
                    }).then(function(e) {
                        a.material[i.map_type] = e, a.material.color = new l.Color(c.color), a.material.transparent = c.transparent, 
                        t();
                    }).catch(e);
                });
            };
        }, {} ],
        72: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.recipe, r = e.componentName, o = e.productOption;
                if (this.productOptions.isValid({
                    sku: t.pdm,
                    componentName: r,
                    productOption: o
                }) && null === this.getSceneObjectByName({
                    objectName: o.options.states.on.componentName
                })) return !0;
                return !1;
            };
        }, {} ],
        73: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var o = e.recipe, t = e.componentName, r = e.productOption;
                if (!o || !o.components || !o.components[t]) return !1;
                if (!r || !r.path || !r.options) return !1;
                var n = o.components[t].product_option, a = void 0 === n ? [] : n, i = r.path, s = Array.isArray(a) && 0 <= a.indexOf(i), c = Object.keys(o.components).filter(function(e) {
                    var t = o.components[e].product_option, r = void 0 === t ? [] : t;
                    return Array.isArray(r) && 0 <= r.indexOf(i);
                });
                return s && 1 === c.length;
            };
        }, {} ],
        74: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.recipe, r = e.productOption, o = "off";
                return "swatch" !== r.options.behavior && t.components[r.componentName] || (o = "on"), 
                o;
            };
        }, {} ],
        75: [ function(e, t, r) {
            "use strict";
            var o = e("./checkValidApply"), n = e("./checkValidRemove"), a = e("./getProductOptionState"), i = e("./applyPlane"), s = e("./removePlane");
            t.exports = function(e) {
                var t = e || this;
                return {
                    checkValidApply: o.bind(t),
                    checkValidRemove: n.bind(t),
                    getProductOptionState: a.bind(t),
                    removePlane: s.bind(t),
                    applyPlane: i.bind(t)
                };
            };
        }, {
            "./applyPlane": 71,
            "./checkValidApply": 72,
            "./checkValidRemove": 73,
            "./getProductOptionState": 74,
            "./removePlane": 76
        } ],
        76: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.planeComponent, r = this.getSceneObjectByName({
                    objectName: t
                });
                this.disposeMeshObject({
                    meshObject: r
                }), this.getModel().remove(r);
            };
        }, {} ],
        77: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.componentName, r = e.productOption, o = e.recipe || this.getRecipe();
                if (!o || !o.components) throw new Error("Unable to parse from recipe");
                Array.isArray(o.components[t].product_option) || (o.components[t].product_option = []), 
                this.hasProductOption({
                    componentName: t,
                    productOption: r,
                    recipe: o
                }) || o.components[t].product_option.push(r);
            };
        }, {} ],
        78: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.componentName, r = null, o = this.getRecipe().components[t];
                return o && o.ugc && (r = o.ugc), r;
            };
        }, {} ],
        79: [ function(e, t, r) {
            "use strict";
            t.exports = function() {
                return this.recipe_v2;
            };
        }, {} ],
        80: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.componentName, r = e.productOption, o = e.recipe || this.getRecipe();
                if (o && o.components) {
                    var n = o.components[t];
                    return !(!n || !Array.isArray(n.product_option)) && 0 <= n.product_option.indexOf(r);
                }
                throw new Error("Unable to parse from recipe");
            };
        }, {} ],
        81: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.componentName, r = e.productOption, o = e.recipe || this.getRecipe();
                if (!o || !o.components) throw new Error("Unable to parse from recipe");
                var n = o.components[t].product_option;
                n && (this.hasProductOption({
                    componentName: t,
                    productOption: r,
                    recipe: o
                }) && n.splice(n.indexOf(r), 1), n.length || delete o.components[t].product_option);
            };
        }, {} ],
        82: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.recipe_v2;
                return this.recipe_v2 = t;
            };
        }, {} ],
        83: [ function(e, t, r) {
            "use strict";
            t.exports = function() {
                return this.rootObj;
            };
        }, {} ],
        84: [ function(e, t, r) {
            "use strict";
            t.exports = function() {
                return this.sceneObject;
            };
        }, {} ],
        85: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.componentName, r = 0 < t.indexOf("_clone") ? t : t + "_clone";
                return this.getSceneObjectByName({
                    objectName: r
                });
            };
        }, {} ],
        86: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.objectName, r = this.getScene();
                if (r) {
                    var o = r.getObjectByName(t);
                    return o || null;
                }
                throw new Error("No scene was set up");
            };
        }, {} ],
        87: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.componentName;
                this.setSceneObjectVisibility({
                    componentName: t,
                    visible: !1
                });
            };
        }, {} ],
        88: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = this.getModel();
                return !!t && (t.remove(e), delete this.getModelComponents()[e.name], !0);
            };
        }, {} ],
        89: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = this.getModel();
                if (t) {
                    if (!t.getObjectByName(e)) return !1;
                    var r = this.getModelComponents();
                    return t.remove(t.getObjectByName(e)), delete r[e], !0;
                }
                return !1;
            };
        }, {} ],
        90: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.componentName, r = this.getSceneObjectByName({
                    objectName: t
                });
                return r && r.material ? r.material : null;
            };
        }, {} ],
        91: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.object3d;
                this.rootObj = t;
            };
        }, {} ],
        92: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.scene;
                this.sceneObject = null, this.sceneObject = t;
            };
        }, {} ],
        93: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.objectName, r = e.mapType, o = e.materialObj, n = this.getModel();
                return !!n && (n.getObjectByName(t).material[r] = o, !0);
            };
        }, {} ],
        94: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.objectName, r = e.mapType, o = e.materialObj, n = this.getModel();
                return !!n && (n.getObjectByName(t).material[r] = o, !0);
            };
        }, {} ],
        95: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.componentName, r = e.visible, o = this.getModel();
                if (!o) throw new Error("The object " + t + " does not exist");
                var n = o.getObjectByName(t);
                n && (n.visible = r);
            };
        }, {} ],
        96: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.componentName;
                this.setSceneObjectVisibility({
                    componentName: t,
                    visible: !0
                });
            };
        }, {} ],
        97: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.material, r = e.shaders, o = e.uniforms;
                r = r || {};
                var n = this.opts.THREE, a = {
                    stitchColor: {
                        type: "c",
                        value: t && t.shader && t.shader.uniforms.stitchColor ? t.shader.uniforms.stitchColor : t.color ? t.color : new n.Color(1, 1, 1)
                    },
                    highLightColor: {
                        type: "c",
                        value: new n.Color(this.getHighlightColor())
                    },
                    highLightAlpha: {
                        type: "f",
                        value: 0
                    },
                    useHighLight: {
                        type: "i",
                        value: 0
                    },
                    normalRepeat: {
                        type: "f",
                        value: 1
                    }
                };
                if (o) for (var i in o) a[i] && (a[i].value = o[i]);
                return this.ShaderMaterialService.MaterialBuilderFactory.consumeShaderChunks({
                    material: t,
                    shaders: r,
                    uniforms: a
                }), t;
            };
        }, {} ],
        98: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.componentName, r = this.getRecipe(), o = this.getPdm(), n = r.components[t], a = o.components[t];
                return n && n.ugc ? a.ugc.shader_material : a.shader_material;
            };
        }, {} ],
        99: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.material, r = e.uniformName;
                return t && t.uniforms ? t.uniforms[r] : {};
            };
        }, {} ],
        100: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.material, r = e.uniformName, o = e.value;
                return t && t.uniforms && t.uniforms[r] ? this.ShaderMaterialService.MaterialBuilderFactory.setUniform({
                    material: t,
                    uniformName: r,
                    value: o
                }) : (t && t.userData.shader && t.userData.shader.uniforms && t.userData.shader.uniforms[r] && (t.userData.shader.uniforms[r].value = o), 
                t);
            };
        }, {} ],
        101: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.componentName, r = this.getPdm();
                return r && r.components[t] && r.components[t].stitches;
            };
        }, {} ],
        102: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.componentName, r = this.getRecipe(), o = this.getPdm(), n = void 0, a = r.components[t];
                if (a) {
                    var i = this.getSwatch({
                        swatchId: a.swatch_id
                    });
                    i && (n = i.stitch_color), a.ugc && a.ugc.tonal_stitch_color && (n = a.ugc.tonal_stitch_color);
                } else n = o.components[t].stitches.material_options.mesh_options.color;
                return n;
            };
        }, {} ],
        103: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.componentName, r = e.swatchObj, o = e.color;
                if (!this.componentHasStitching({
                    componentName: t
                }) && "deco" !== t) return !1;
                var n = o, a = this.opts.THREE, i = this.getSceneObjectByName({
                    objectName: t + "_stitches"
                });
                n || (n = this.returnStitchColor({
                    componentName: t,
                    recipe_v2: this.getRecipe()
                })) || (n = r.stitch_color), i && (i.material.color = new a.Color(n));
            };
        }, {} ],
        104: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var n = this, t = e.componentName, r = e.material_groups, a = e.swatchObj, i = [], o = this.validateSwatchMaterialGroup({
                    material_groups: r,
                    componentName: t
                }), s = o && o[t];
                return s && Object.keys(s).forEach(function(e) {
                    if (n.getSceneObjectByName({
                        objectName: e
                    })) {
                        var t = JSON.parse(JSON.stringify(s[e].material_options)), r = s[e].material_name, o = a.material_overrides && a.material_overrides[r] && a.material_overrides[r].mesh_options;
                        t.mesh_options = n.overrideMeshOptions({
                            baseMeshOptions: t.mesh_options,
                            uniqueMeshOptions: o
                        }), i.push(n.loadTexturesApplyMaterials({
                            textureList: t.textures,
                            swatchObj: a,
                            componentName: e,
                            componentMaterialOptions: t,
                            materialName: r
                        }));
                    }
                }), Promise.all(i);
            };
        }, {} ],
        105: [ function(e, t, r) {
            "use strict";
            t.exports = function() {
                return this.swatchMaterialGroupsData;
            };
        }, {} ],
        106: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.baseMeshOptions, r = e.uniqueMeshOptions;
                if (!t || !r) return r || t;
                var o = JSON.parse(JSON.stringify(t)), n = JSON.parse(JSON.stringify(r));
                return Object.assign(o, n);
            };
        }, {} ],
        107: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.groups;
                this.swatchMaterialGroupsData = t;
            };
        }, {} ],
        108: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.material_groups, r = e.componentName;
                if (!t) return !1;
                var o = {}, n = this.getSwatchMaterialGroupsData();
                return t.forEach(function(t) {
                    var e = n.filter(function(e) {
                        return e[t] && e.component_name === r;
                    });
                    e[0] && e[0][t] && (o[r] = e[0][t]);
                }), o;
            };
        }, {} ],
        109: [ function(e, t, r) {
            "use strict";
            var o, n;
            t.exports = (o = regeneratorRuntime.mark(function e(t, r) {
                var o, n, a, i, s, c = t.componentName, u = t.swatchObj;
                return regeneratorRuntime.wrap(function(e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        if (o = this.opts.THREE, e.prev = 1, n = this.getSceneObjectByName({
                            objectName: c
                        }), a = this.getDefaultTextures(), i = this.getPdm(), s = i.components, n) {
                            e.next = 8;
                            break;
                        }
                        return r(), e.abrupt("return", !1);

                      case 8:
                        if (a && a.hasOwnProperty(c) && 0 < Object.keys(a[c]).length) return e.next = 11, 
                        this.createMaterial({
                            mesh_type: s[c].mesh_material.mesh_type,
                            options: s[c].mesh_material.mesh_options,
                            componentName: c,
                            shadersType: this.getUVType({
                                componentName: c
                            })
                        });
                        e.next = 15;
                        break;

                      case 11:
                        n.material = n.material = e.sent, n.material.color = new o.Color(u.color), e.next = 17;
                        break;

                      case 15:
                        n.material.map = null, n.material.color = new o.Color(u.color);

                      case 17:
                        return e.next = 19, new Promise(function(e) {
                            return requestAnimationFrame(function() {
                                return e();
                            });
                        });

                      case 19:
                        u.normal_repeat && this.setUniform({
                            material: n.material,
                            uniformName: "normalRepeat",
                            value: u.normal_repeat
                        }), this.storeMaterial({
                            swatchId: u.id,
                            componentName: c
                        }), u.stitch_color && this.componentHasStitching({
                            componentName: c
                        }) && this.updateComponentStitching({
                            componentName: c,
                            swatchObj: u
                        }, r), r && r(), e.next = 30;
                        break;

                      case 25:
                        if (e.prev = 25, e.t0 = e.catch(1), r) return e.abrupt("return", r(e.t0));
                        e.next = 29;
                        break;

                      case 29:
                        throw e.t0;

                      case 30:
                      case "end":
                        return e.stop();
                    }
                }, e, this, [ [ 1, 25 ] ]);
            }), n = function() {
                var s = o.apply(this, arguments);
                return new Promise(function(a, i) {
                    return function t(e, r) {
                        try {
                            var o = s[e](r), n = o.value;
                        } catch (e) {
                            return void i(e);
                        }
                        if (!o.done) return Promise.resolve(n).then(function(e) {
                            t("next", e);
                        }, function(e) {
                            t("throw", e);
                        });
                        a(n);
                    }("next");
                });
            }, function(e, t) {
                return n.apply(this, arguments);
            });
        }, {} ],
        110: [ function(e, t, r) {
            "use strict";
            function o(e) {
                return function() {
                    var s = e.apply(this, arguments);
                    return new Promise(function(a, i) {
                        return function t(e, r) {
                            try {
                                var o = s[e](r), n = o.value;
                            } catch (e) {
                                return void i(e);
                            }
                            if (!o.done) return Promise.resolve(n).then(function(e) {
                                t("next", e);
                            }, function(e) {
                                t("throw", e);
                            });
                            a(n);
                        }("next");
                    });
                };
            }
            var n;
            t.exports = (n = o(regeneratorRuntime.mark(function e(t) {
                var n, a = this, i = t.swatchObj, s = t.componentName, c = t.componentMaterialOptions, u = t.textures;
                return regeneratorRuntime.wrap(function(e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        return n = this.opts.THREE, e.abrupt("return", new Promise(function() {
                            var t = o(regeneratorRuntime.mark(function e(t) {
                                var r, o;
                                return regeneratorRuntime.wrap(function(e) {
                                    for (;;) switch (e.prev = e.next) {
                                      case 0:
                                        if (r = a.getSceneObjectByName({
                                            objectName: s
                                        }), o = a.getModelComponents(), r) {
                                            e.next = 4;
                                            break;
                                        }
                                        return e.abrupt("return", t());

                                      case 4:
                                        return a.ShaderMaterialService.ComponentShadersUpdates.updateUVAttributes(o[s]), 
                                        r && r.material && a.disposeMaterial({
                                            material: r.material
                                        }), e.next = 8, a.createMaterial({
                                            mesh_type: c.type,
                                            options: Object.assign({}, c.mesh_options, u),
                                            componentName: s,
                                            shadersType: i.uvState || a.getUVType({
                                                componentName: s
                                            })
                                        });

                                      case 8:
                                        return o[s].material = r.material = e.sent, c.mesh_options.color && (o[s].material.color = r.material.color = new n.Color(c.mesh_options.color)), 
                                        e.next = 12, new Promise(function(e) {
                                            return requestAnimationFrame(function() {
                                                return e();
                                            });
                                        });

                                      case 12:
                                        i.normal_repeat && a.setUniform({
                                            material: r.material,
                                            uniformName: "normalRepeat",
                                            value: i.normal_repeat
                                        }), a.storeMaterial({
                                            swatchId: i.id,
                                            componentName: s
                                        }), a.updateComponentStitching({
                                            componentName: s,
                                            swatchObj: i
                                        }), a.meshMaterialOverride({
                                            swatchObj: i,
                                            componentObj: r
                                        }), t();

                                      case 17:
                                      case "end":
                                        return e.stop();
                                    }
                                }, e, a);
                            }));
                            return function(e) {
                                return t.apply(this, arguments);
                            };
                        }()));

                      case 2:
                      case "end":
                        return e.stop();
                    }
                }, e, this);
            })), function(e) {
                return n.apply(this, arguments);
            });
        }, {} ],
        111: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.component;
                this.ShaderMaterialService.ComponentShadersUpdates.updateUVAttributes(t);
                var r = this.ShaderMaterialService.getShaders(), o = this.ShaderMaterialService.FilteredShaders.getShadersForComponent({
                    component: t,
                    shaders: r
                });
                this.ShaderMaterialService.MaterialBuilderFactory.consumeShaderChunks({
                    material: t.material,
                    shaders: o
                });
            };
        }, {} ],
        112: [ function(e, t, r) {
            "use strict";
            t.exports = function(e, t) {
                var r = e.swatchId, o = e.material, n = e.componentName, a = (e.componentsWithStitches, 
                this.getSceneObjectByName({
                    objectName: n
                })), i = this.getSwatch({
                    swatchId: r
                });
                i.color && !i.image_assets.map ? (a.material.color = o.color, null === o.map && (a.material.map = null)) : a.material = o, 
                this.storeMaterial({
                    swatchId: r,
                    componentName: n
                });
            };
        }, {} ],
        113: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.componentName, r = e.swatchObj, o = e.componentMaterialOptions, n = e.templateMaterial, a = n && n.material_options && n.material_options.textures, i = this.returnOverrideTexturesList({
                    templateMaterialTextures: a,
                    swatchTextures: o && o.textures
                }), s = n && n.material_name || "", c = n && n.material_options.mesh_options, u = n && JSON.parse(JSON.stringify(n.material_options)) || o && JSON.parse(JSON.stringify(o));
                return u.mesh_options = this.overrideMeshOptions({
                    baseMeshOptions: c,
                    uniqueMeshOptions: o && o.mesh_options
                }), this.loadTexturesApplyMaterials({
                    textureList: i,
                    swatchObj: r,
                    componentName: t,
                    componentMaterialOptions: u,
                    materialName: s
                });
            };
        }, {} ],
        114: [ function(e, t, r) {
            "use strict";
            t.exports = function(e, t) {
                var o = this, n = e.swatchId, r = e.componentName, a = e.componentGroup, i = e.templateMaterial, s = this.getSwatch({
                    swatchId: n
                }), c = s.material_options, u = this.validateSwatchMaterialGroup({
                    material_groups: s.material_groups,
                    componentName: r
                }), l = u && Object.keys(u).includes(r);
                new Promise(function(e, t) {
                    if (s.material_groups && l) o.applySwatchMaterialGroup({
                        componentName: r,
                        swatchObj: s,
                        material_groups: s.material_groups
                    }).then(e).catch(t); else {
                        if (!c && !i) return console.warn("Unable to process swatch: " + n), t(new Error("Unable to process swatch: " + n));
                        o.applySwatchMaterialOptions({
                            componentName: r,
                            swatchObj: s,
                            componentMaterialOptions: c,
                            templateMaterial: i
                        }).then(e).catch(t);
                    }
                }).then(function() {
                    Array.isArray(a) && a.length && !l ? Promise.all(a.filter(function(e) {
                        return e !== r;
                    }).map(function(e) {
                        return new Promise(function(t, r) {
                            o.changeSwatch({
                                swatchId: n,
                                componentName: e,
                                templateMaterial: i
                            }, function(e) {
                                if (e) return r(e);
                                t();
                            });
                        });
                    })).then(function() {
                        t();
                    }).catch(t) : t();
                }).catch(t);
            };
        }, {} ],
        115: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.swatchId;
                if (t) {
                    var r = Number(t), o = this.swatches.filter(function(e) {
                        return r === Number(e.id);
                    });
                    if (o.length) return o[0];
                }
                return null;
            };
        }, {} ],
        116: [ function(e, t, r) {
            "use strict";
            t.exports = function() {
                return this.swatches;
            };
        }, {} ],
        117: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.swatchObj, r = e.componentObj;
                t && t.meshMaterialOverride && t.meshMaterialOverride.forEach(function(e) {
                    r.material[e.property] = e.value;
                });
            };
        }, {} ],
        118: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.swatches;
                this.swatches = t;
            };
        }, {} ],
        119: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.mesh, r = e.options, o = this.opts.THREE;
                for (var n in r) /^#[0-9A-F]{6}$/i.test(r[n]) ? t.material[n] = new o.Color(r[n]) : Array.isArray(r[n]) && "function" == typeof t.material[n].set ? t.material[n].set(Number(r[n][0]), Number(r[n][1])) : t.material[n] = r[n];
            };
        }, {} ],
        120: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                return void 0 !== e && (this.useRecipe = e), this.useRecipe;
            };
        }, {} ],
        121: [ function(e, t, r) {
            "use strict";
            t.exports = function(e, t, r) {
                var o = e.width, n = e.height, a = e.getContext("2d"), i = a.getImageData(0, 0, o, n), s = void 0;
                if ("webgl" === r) {
                    var c = t.getContext("webgl");
                    s = new Uint8Array(4 * o * n), c.readPixels(0, 0, o, n, c.RGBA, c.UNSIGNED_BYTE, s);
                } else {
                    s = t.getContext("2d").getImageData(0, 0, o, n).data;
                }
                var u = void 0, l = void 0, p = void 0;
                for (u = 0; u < n; ++u) for (l = 0; l < o; ++l) 0 !== s[(p = 4 * (u * o + l)) + 3] && (i.data[p] = s[p], 
                i.data[p + 1] = s[p + 1], i.data[p + 2] = s[p + 2], i.data[p + 3] = s[p + 3]);
                a.putImageData(i, 0, 0);
            };
        }, {} ],
        122: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "2d", r = e.width, o = e.height, n = sceneHelpers.createCanvas({
                    width: r,
                    height: o
                }), a = n.getContext("2d"), i = void 0;
                i = e && e.data ? e.data : (a.drawImage(e, 0, 0, r, o, t), a.getImageData(0, 0, r, o));
                for (var s = a.createImageData(r, o), c = 0, u = r * o * 4; c < u; c += 4) s.data[c] = 255, 
                s.data[c + 1] = 255, s.data[c + 2] = 255, s.data[c + 3] = .2126 * i[c] + .7152 * i[c + 1] + .0722 * i[c + 2];
                return a.putImageData(s, 0, 0), n;
            };
        }, {} ],
        123: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "2d", r = e.width, o = e.height, n = sceneHelpers.createCanvas({
                    width: r,
                    height: o
                }), a = n.getContext("2d"), i = [];
                i = e && e.data ? e.data : (a.drawImage(e, 0, 0, r, o, t), a.getImageData(0, 0, r, o));
                for (var s = a.createImageData(r, o), c = 0, u = r * o * 4; c < u; c += 4) {
                    var l = void 0, p = void 0, h = void 0, m = void 0;
                    p = c % (4 * r) == 0 ? (l = i[c], i[c + 4]) : c % (4 * r) == 4 * (r - 1) ? (l = i[c - 4], 
                    i[c]) : (l = i[c - 4], i[c + 4]), m = c < 4 * r ? (h = i[c], i[c + 4 * r]) : r * (o - 1) * 4 < c ? (h = i[c - 4 * r], 
                    i[c]) : (h = i[c - 4 * r], i[c + 4 * r]), s.data[c] = l - p + 127, s.data[c + 1] = h - m + 127, 
                    s.data[c + 2] = 255, s.data[c + 3] = 255;
                }
                return a.putImageData(s, 0, 0), n;
            };
        }, {} ],
        124: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.width, r = e.height;
                return this.canvasFactory(t, r);
            };
        }, {} ],
        125: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.threeObj || e;
                if (t) try {
                    t.dispose();
                    var r = this.getScene();
                    r && r.remove(t);
                } catch (e) {
                    console.log("Error disposing element", e);
                }
            };
        }, {} ],
        126: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = this, r = e.material;
                if (r) {
                    [ "map", "alphaMap", "aoMap", "bumpMap", "lightMap", "normalMap", "roughnessMap", "specularMap" ].forEach(function(e) {
                        r[e] && t.dispose(r[e]);
                    }), this.dispose(r);
                }
            };
        }, {} ],
        127: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.meshObject;
                t.geometry && this.dispose(t.geometry), t.material && this.disposeMaterial({
                    material: t.material
                }), this.getScene().remove(t);
            };
        }, {} ],
        128: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.textureObj;
                t.material.map && this.dispose(t.material.map), this.dispose(t.material);
            };
        }, {} ],
        129: [ function(e, t, r) {
            "use strict";
            t.exports = function() {
                return this.default_textures;
            };
        }, {} ],
        130: [ function(e, t, r) {
            "use strict";
            function o(e) {
                e = e || {}, this.canvas = e.canvas || null, this.flipY = e.flipY || !1, this.width = e.width || 1024, 
                this.height = e.height || 1024, this.buffers = e.buffers || [ 0 ], this.uniforms = e.uniforms || [], 
                this.vertexShaderSource = e.vertexShaderSource || "attribute vec3 a_position;\nattribute vec2 a_uv;\nvarying vec2 v_uv;\nvoid main(void) {\n  gl_Position = vec4(a_position, 1.0);\n  v_uv = a_uv;\n}\n", 
                this.fragmentShaderSource = e.fragmentShaderSource || "#ifdef GL_ES\n  precision mediump float;\n#endif\nuniform sampler2D u_image;\nvarying vec2 v_uv;\nvoid main(void) {\n  gl_FragColor = texture2D(u_image, v_uv);\n}\n";
            }
            o.prototype.initShaderProgram = function(e, t, r) {
                var o = null;
                if (e) {
                    this.vertexShaderSource = t || this.vertexShaderSource, this.fragmentShaderSource = r || this.fragmentShaderSource;
                    var n = this.loadShader(e, e.VERTEX_SHADER, this.vertexShaderSource), a = this.loadShader(e, e.FRAGMENT_SHADER, this.fragmentShaderSource);
                    o = e.createProgram(), e.attachShader(o, n), e.attachShader(o, a), e.linkProgram(o), 
                    e.getProgramParameter(o, e.LINK_STATUS) || (console.error("Unable to initialize the shader program: " + e.getProgramInfoLog(o)), 
                    o = null);
                }
                return o;
            }, o.prototype.loadShader = function(e, t, r) {
                var o = null;
                return e && (o = e.createShader(t), e.shaderSource(o, r), e.compileShader(o), e.getShaderParameter(o, e.COMPILE_STATUS) || (console.error("An error occurred compiling the shaders: " + e.getShaderInfoLog(o)), 
                e.deleteShader(o), o = null)), o;
            }, o.prototype.attachBuffer = function(e, t, r, o, n) {
                if (e && t) {
                    var a = e.getAttribLocation(t, r);
                    e.enableVertexAttribArray(a);
                    var i = e.createBuffer();
                    e.bindBuffer(e.ARRAY_BUFFER, i), e.bufferData(e.ARRAY_BUFFER, o, e.STATIC_DRAW), 
                    i.itemSize = n || 2, i.numItems = Math.round(o.length / n), e.vertexAttribPointer(a, i.itemSize, e.FLOAT, !1, 0, 0);
                }
            }, o.prototype.attachTexture = function(e, t, r) {
                var o = null;
                return e && t && (o = e.createTexture(), e.bindTexture(e.TEXTURE_2D, o), e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, e.RGBA, e.UNSIGNED_BYTE, r), 
                e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE), 
                e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.NEAREST), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.NEAREST)), 
                o;
            }, o.prototype.bindTexture = function(e, t, r, o, n) {
                if (e && t && n) {
                    var a = e.getUniformLocation(t, r);
                    e.uniform1i(a, o), e.activeTexture(e.TEXTURE0 + o), e.bindTexture(e.TEXTURE_2D, n);
                }
            }, o.prototype.render = function(e) {
                var t = this;
                e && (this.canvas = e.canvas || this.canvas, this.width = e.width || this.width, 
                this.height = e.height || this.height, this.buffers = e.buffers || this.buffers, 
                this.uniforms = e.uniforms || this.uniforms, this.vertexShaderSource = e.vertexShaderSource || this.vertexShaderSource, 
                this.fragmentShaderSource = e.fragmentShaderSource || this.fragmentShaderSource, 
                this.flipY = e.flipY || this.flipY, this.itemCount = e.itemCount || 0);
                var r = this.gl = this.canvas.getContext("webgl", {
                    preserveDrawingBuffer: !0
                }), o = r ? this.initShaderProgram(r) : null;
                if (r && o) {
                    var n = r.TRIANGLE_STRIP;
                    r.useProgram(o);
                    for (var a = 0; a < this.buffers.length; ++a) {
                        var i = this.buffers[a];
                        if ("uvs" === i.type) {
                            var s = [];
                            if (this.flipY) for (var c = 0; c < i.value.length; ++c) {
                                var u = i.value[c];
                                s.push(u[0].x, 1 - u[0].y, u[1].x, 1 - u[1].y, u[2].x, 1 - u[2].y);
                            } else for (var l = 0; l < i.value.length; ++l) {
                                var p = i.value[l];
                                s.push(p[0].x, p[0].y, p[1].x, p[1].y, p[2].x, p[2].y);
                            }
                            this.attachBuffer(r, o, i.name, new Float32Array(s), 2);
                        } else if ("position" === i.type) {
                            for (var h = [], m = 0; m < i.value.length; ++m) {
                                var d = i.value[m];
                                h.push(this.width * d[0].x, this.height - this.height * d[0].y, this.width * d[1].x, this.height - this.height * d[1].y, this.width * d[2].x, this.height - this.height * d[2].y);
                            }
                            n = r.TRIANGLES, this.itemCount = h.length / 2, this.attachBuffer(r, o, i.name, new Float32Array(h), 2);
                        } else this.itemCount = this.itemCount ? this.itemCount : i.value.length / i.itemSize, 
                        this.attachBuffer(r, o, i.name, i.value, i.itemSize);
                    }
                    var f = 0, v = [];
                    this.uniforms.forEach(function(e) {
                        "texture" === e.type ? v[f++] = t.attachTexture(r, o, e.value) : "color" === e.type ? r.uniform4fv(r.getUniformLocation(o, e.name), new Float32Array([ e.value.r, e.value.g, e.value.b, e.value.a ])) : "vec4" === e.type ? r.uniform4fv(r.getUniformLocation(o, e.name), new Float32Array([ e.value[0], e.value[1], e.value[2], e.value[3] ])) : "vec3" === e.type ? r.uniform3fv(r.getUniformLocation(o, e.name), new Float32Array([ e.value[0], e.value[1], e.value[2] ])) : "vec2" === e.type ? r.uniform2fv(r.getUniformLocation(o, e.name), new Float32Array([ e.value[0], e.value[1] ])) : "float" === e.type && r.uniformf1(r.getUniformLocation(o, e.name), e.value);
                    }), r.uniform2f(r.getUniformLocation(o, "u_resolution"), this.width, this.height), 
                    f = 0, this.uniforms.forEach(function(e) {
                        "texture" === e.type && t.bindTexture(r, o, e.name, f, v[f++]);
                    }), r.viewport(0, 0, this.width, this.height), r.clearColor(0, 0, 0, 0), r.enable(r.DEPTH_TEST), 
                    r.clear(r.COLOR_BUFFER_BIT | r.DEPTH_BUFFER_BIT), r.drawArrays(n, 0, this.itemCount);
                }
                return this.gl;
            }, t.exports = function(e) {
                return new o(e);
            };
        }, {} ],
        131: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.manager, r = this.opts.THREE, o = null;
                return r && r.hasOwnProperty(this.textureLoaderMode.name) ? (r[this.textureLoaderMode.name].prototype.crossOrigin = "", 
                o = new r[this.textureLoaderMode.name](t)) : this.opts.hasOwnProperty(this.textureLoaderMode.name) && (o = new this.opts[this.textureLoaderMode.name](t)), 
                {
                    loader: o,
                    fileType: this.textureLoaderMode.fileType,
                    format: this.textureLoaderMode.format
                };
            };
        }, {} ],
        132: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.path;
                return this.loadTexture({
                    path: t
                });
            };
        }, {} ],
        133: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var n = e.path;
                return new Promise(function(t, r) {
                    var o = new Image();
                    o.onload = function(e) {
                        t(o);
                    }, o.onerror = function(e) {
                        r(e);
                    }, o.crossOrigin = "Anonymous", o.src = n;
                });
            };
        }, {} ],
        134: [ function(e, t, r) {
            "use strict";
            t.exports = function(t) {
                var n = this, a = [], i = {};
                if (t) {
                    var e = function(r) {
                        var e = t[r], o = (i[r] = e).image.currentSrc || e.image.src;
                        e.image instanceof Image || a.push(new Promise(function(t, e) {
                            n.loadImage({
                                path: o
                            }).then(function(e) {
                                i[r].image = e, t();
                            }).catch(e);
                        }));
                    };
                    for (var r in t) e(r);
                }
                return new Promise(function(e, t) {
                    Promise.all(a).then(function() {
                        e(i);
                    }).catch(t);
                });
            };
        }, {} ],
        135: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var n = this, a = e.textureList, i = e.materialName;
                if (!a) return Promise.resolve();
                var t = Object.keys(a), s = [], r = t.map(function(t) {
                    var e = a[t].image_url, r = i + "_" + e.substring(e.lastIndexOf("/") + 1, e.lastIndexOf(".")), o = n.returnAppliedTexture({
                        textureName: r
                    });
                    return o ? (s.push({
                        name: t,
                        texture: o
                    }), Promise.resolve()) : n.loadTexture({
                        path: "" + n.swatchesRoot + a[t].image_url,
                        options: a[t].options
                    }).then(function(e) {
                        s.push({
                            name: t,
                            texture: e
                        }), n.saveAppliedTexture({
                            textureName: r,
                            textureObj: e
                        });
                    });
                });
                return Promise.all(r).then(function() {
                    var o = {};
                    return s.forEach(function(e) {
                        var t = e.name, r = e.texture;
                        return o[t] = r;
                    }), o;
                }).catch(function(e) {
                    return console.log("loadMultipleTextures: ", e);
                });
            };
        }, {} ],
        136: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var o = this, n = e.path, t = e.options, a = e.textureLoader, i = e.manager, s = this.opts.THREE, c = Object.assign({
                    wrapS: "RepeatWrapping",
                    wrapT: "RepeatWrapping",
                    offset: [ 0, 0 ],
                    repeat: [ 1, 1 ]
                }, t);
                return new Promise(function(r, t) {
                    try {
                        n = n.replace(/([^:]\/)\/+/g, "$1"), (a = a || o.getTextureLoader({
                            manager: i
                        }).loader).load(n, function(e) {
                            for (var t in e.flipY = !1, c) e.hasOwnProperty(t) && ("string" == typeof c[t] && s.hasOwnProperty(c[t]) ? e[t] = s[c[t]] : Array.isArray(c[t]) && "function" == typeof e[t].set ? e[t].set.apply(e[t], c[t]) : "boolean" == typeof c[t] ? e[t] = Boolean(c[t]) : isNaN(c[t]) || (e[t] = Number(c[t])));
                            r(e);
                        }, null, function(e) {
                            t(new Error("Error loading texture " + n + ": " + e));
                        });
                    } catch (e) {
                        t(new Error("Error loading texture " + n + ": " + e));
                    }
                });
            };
        }, {} ],
        137: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var r = this, o = e.textureList, n = e.swatchObj, a = e.componentName, i = e.componentMaterialOptions, s = e.materialName;
                return new Promise(function(e, t) {
                    r.loadMultipleTextures({
                        textureList: o,
                        materialName: s
                    }).then(function(e) {
                        return r.applyMaterial({
                            swatchObj: n,
                            componentName: a,
                            componentMaterialOptions: i,
                            textures: e
                        });
                    }).then(e).catch(t);
                });
            };
        }, {} ],
        138: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.textureName;
                if (this.applied_textures) return this.applied_textures[t];
            };
        }, {} ],
        139: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.templateMaterialTextures, r = e.swatchTextures;
                if (!t || !r) return t || r;
                var o = JSON.parse(JSON.stringify(r));
                return Object.assign(t, o);
            };
        }, {} ],
        140: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.textureName, r = e.textureObj;
                this.applied_textures || (this.applied_textures = {}), this.applied_textures[t] = r;
            };
        }, {} ],
        141: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.default_textures;
                this.default_textures = t;
            };
        }, {} ],
        142: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.textureLoaderName, r = e.format, o = e.fileType, n = e.compress, a = e.renderer, i = this.opts.THREE;
                if (this.textureLoaderMode.name = "TextureLoader", this.textureLoaderMode.format = null, 
                this.textureLoaderMode.fileType = null, "string" == typeof t) (i && i.hasOwnProperty(t) || this.opts.hasOwnProperty(t)) && (this.textureLoaderMode.name = t, 
                this.textureLoaderMode.format = r, this.textureLoaderMode.fileType = o); else if (n) try {
                    if (!a && i && (a = new i.WebGLRenderer()), a && a.extensions) {
                        var s = a.extensions.get("WEBGL_compressed_texture_astc"), c = (a.extensions.get("WEBGL_compressed_texture_atc"), 
                        a.extensions.get("WEBGL_compressed_texture_etc"), a.extensions.get("WEBGL_compressed_texture_etc1"), 
                        a.extensions.get("WEBGL_compressed_texture_pvrtc")), u = a.extensions.get("WEBGL_compressed_texture_s3tc");
                        a.extensions.get("WEBGL_compressed_texture_s3tc_srgb");
                        (s || c) && i && i.KTXLoader ? (this.textureLoaderMode.name = "KTXLoader", this.textureLoaderMode.format = s ? "astc" : "pvrtc", 
                        this.textureLoaderMode.fileType = "ktx") : u && i && i.DDSLoader && (this.textureLoaderMode.name = "DDSLoader", 
                        this.textureLoaderMode.format = "s3tc", this.textureLoaderMode.fileType = "dds");
                    }
                } catch (e) {
                    console.error(new Error("Error creating WebGL context"));
                }
            };
        }, {} ],
        143: [ function(e, t, r) {
            "use strict";
            var o = e("browser-or-node"), n = e("./SceneHelpers"), a = void 0;
            t.exports = function(e) {
                return a || (this.opts = Object.assign(o, e), this.sceneHelpers = new n(this.opts), 
                a = this);
            };
        }, {
            "./SceneHelpers": 1,
            "browser-or-node": 144
        } ],
        144: [ function(e, t, a) {
            (function(n) {
                (function() {
                    "use strict";
                    Object.defineProperty(a, "__esModule", {
                        value: !0
                    });
                    var e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, t = "undefined" != typeof window && void 0 !== window.document, r = "object" === ("undefined" == typeof self ? "undefined" : e(self)) && self.constructor && "DedicatedWorkerGlobalScope" === self.constructor.name, o = void 0 !== n && null != n.versions && null != n.versions.node;
                    a.isBrowser = t, a.isWebWorker = r, a.isNode = o, a.isJsDom = function() {
                        return "undefined" != typeof window && "nodejs" === window.name || navigator.userAgent.includes("Node.js") || navigator.userAgent.includes("jsdom");
                    };
                }).call(this);
            }).call(this, e("_process"));
        }, {
            _process: 146
        } ],
        145: [ function(e, t, r) {}, {} ],
        146: [ function(e, t, r) {
            var o, n, a = t.exports = {};
            function i() {
                throw new Error("setTimeout has not been defined");
            }
            function s() {
                throw new Error("clearTimeout has not been defined");
            }
            function c(t) {
                if (o === setTimeout) return setTimeout(t, 0);
                if ((o === i || !o) && setTimeout) return o = setTimeout, setTimeout(t, 0);
                try {
                    return o(t, 0);
                } catch (e) {
                    try {
                        return o.call(null, t, 0);
                    } catch (e) {
                        return o.call(this, t, 0);
                    }
                }
            }
            !function() {
                try {
                    o = "function" == typeof setTimeout ? setTimeout : i;
                } catch (e) {
                    o = i;
                }
                try {
                    n = "function" == typeof clearTimeout ? clearTimeout : s;
                } catch (e) {
                    n = s;
                }
            }();
            var u, l = [], p = !1, h = -1;
            function m() {
                p && u && (p = !1, u.length ? l = u.concat(l) : h = -1, l.length && d());
            }
            function d() {
                if (!p) {
                    var e = c(m);
                    p = !0;
                    for (var t = l.length; t; ) {
                        for (u = l, l = []; ++h < t; ) u && u[h].run();
                        h = -1, t = l.length;
                    }
                    u = null, p = !1, function(t) {
                        if (n === clearTimeout) return clearTimeout(t);
                        if ((n === s || !n) && clearTimeout) return n = clearTimeout, clearTimeout(t);
                        try {
                            n(t);
                        } catch (e) {
                            try {
                                return n.call(null, t);
                            } catch (e) {
                                return n.call(this, t);
                            }
                        }
                    }(e);
                }
            }
            function f(e, t) {
                this.fun = e, this.array = t;
            }
            function v() {}
            a.nextTick = function(e) {
                var t = new Array(arguments.length - 1);
                if (1 < arguments.length) for (var r = 1; r < arguments.length; r++) t[r - 1] = arguments[r];
                l.push(new f(e, t)), 1 !== l.length || p || c(d);
            }, f.prototype.run = function() {
                this.fun.apply(null, this.array);
            }, a.title = "browser", a.browser = !0, a.env = {}, a.argv = [], a.version = "", 
            a.versions = {}, a.on = v, a.addListener = v, a.once = v, a.off = v, a.removeListener = v, 
            a.removeAllListeners = v, a.emit = v, a.prependListener = v, a.prependOnceListener = v, 
            a.listeners = function(e) {
                return [];
            }, a.binding = function(e) {
                throw new Error("process.binding is not supported");
            }, a.cwd = function() {
                return "/";
            }, a.chdir = function(e) {
                throw new Error("process.chdir is not supported");
            }, a.umask = function() {
                return 0;
            };
        }, {} ]
    }, {}, [ 143 ])(143);
});